/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedWarrantyClaimsRouteImport } from './routes/_authenticated/warranty-claims'
import { Route as AuthenticatedWarehouseRouteImport } from './routes/_authenticated/warehouse'
import { Route as AuthenticatedTaxRatesRouteImport } from './routes/_authenticated/tax-rates'
import { Route as AuthenticatedTaxExemptionsRouteImport } from './routes/_authenticated/tax-exemptions'
import { Route as AuthenticatedSuppliersRouteImport } from './routes/_authenticated/suppliers'
import { Route as AuthenticatedStoreReadinessRouteImport } from './routes/_authenticated/store-readiness'
import { Route as AuthenticatedStaffRouteImport } from './routes/_authenticated/staff'
import { Route as AuthenticatedSpecialsRouteImport } from './routes/_authenticated/specials'
import { Route as AuthenticatedSourcesRouteImport } from './routes/_authenticated/sources'
import { Route as AuthenticatedShippingCalculatorRouteImport } from './routes/_authenticated/shipping-calculator'
import { Route as AuthenticatedShipmentsRouteImport } from './routes/_authenticated/shipments'
import { Route as AuthenticatedReceivablesRouteImport } from './routes/_authenticated/receivables'
import { Route as AuthenticatedQuotesRouteImport } from './routes/_authenticated/quotes'
import { Route as AuthenticatedQuotedVsActualRouteImport } from './routes/_authenticated/quoted-vs-actual'
import { Route as AuthenticatedQualityTiersRouteImport } from './routes/_authenticated/quality-tiers'
import { Route as AuthenticatedPurchaseOrdersRouteImport } from './routes/_authenticated/purchase-orders'
import { Route as AuthenticatedProjectsRouteImport } from './routes/_authenticated/projects'
import { Route as AuthenticatedProductsRouteImport } from './routes/_authenticated/products'
import { Route as AuthenticatedPriceMatchingRouteImport } from './routes/_authenticated/price-matching'
import { Route as AuthenticatedOrdersRouteImport } from './routes/_authenticated/orders'
import { Route as AuthenticatedOrderReviewRouteImport } from './routes/_authenticated/order-review'
import { Route as AuthenticatedManufacturersRouteImport } from './routes/_authenticated/manufacturers'
import { Route as AuthenticatedLearnRouteImport } from './routes/_authenticated/learn'
import { Route as AuthenticatedInvoicesRouteImport } from './routes/_authenticated/invoices'
import { Route as AuthenticatedE2eTestingRouteImport } from './routes/_authenticated/e2e-testing'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCustomersRouteImport } from './routes/_authenticated/customers'
import { Route as AuthenticatedCustomerCommsRouteImport } from './routes/_authenticated/customer-comms'
import { Route as AuthenticatedContactsRouteImport } from './routes/_authenticated/contacts'
import { Route as AuthenticatedCompanyRouteImport } from './routes/_authenticated/company'
import { Route as AuthenticatedCommunicationsRouteImport } from './routes/_authenticated/communications'
import { Route as AuthenticatedCatalogSourcesRouteImport } from './routes/_authenticated/catalog-sources'
import { Route as AuthenticatedCatalogSearchRouteImport } from './routes/_authenticated/catalog-search'
import { Route as AuthenticatedApVendorsRouteImport } from './routes/_authenticated/ap-vendors'
import { Route as AuthenticatedAnalyticsRouteImport } from './routes/_authenticated/analytics'
import { Route as AuthenticatedAiCostsRouteImport } from './routes/_authenticated/ai-costs'
import { Route as AuthenticatedAiRouteImport } from './routes/_authenticated/ai'
import { Route as AuthenticatedWarehouseIndexRouteImport } from './routes/_authenticated/warehouse.index'
import { Route as AuthenticatedTaxExemptionsIndexRouteImport } from './routes/_authenticated/tax-exemptions.index'
import { Route as AuthenticatedSuppliersIndexRouteImport } from './routes/_authenticated/suppliers.index'
import { Route as AuthenticatedStaffIndexRouteImport } from './routes/_authenticated/staff.index'
import { Route as AuthenticatedShippingCalculatorIndexRouteImport } from './routes/_authenticated/shipping-calculator.index'
import { Route as AuthenticatedShipmentsIndexRouteImport } from './routes/_authenticated/shipments.index'
import { Route as AuthenticatedReceivablesIndexRouteImport } from './routes/_authenticated/receivables.index'
import { Route as AuthenticatedQuotesIndexRouteImport } from './routes/_authenticated/quotes.index'
import { Route as AuthenticatedPurchaseOrdersIndexRouteImport } from './routes/_authenticated/purchase-orders.index'
import { Route as AuthenticatedProjectsIndexRouteImport } from './routes/_authenticated/projects.index'
import { Route as AuthenticatedProductsIndexRouteImport } from './routes/_authenticated/products.index'
import { Route as AuthenticatedOrdersIndexRouteImport } from './routes/_authenticated/orders.index'
import { Route as AuthenticatedOrderReviewIndexRouteImport } from './routes/_authenticated/order-review.index'
import { Route as AuthenticatedManufacturersIndexRouteImport } from './routes/_authenticated/manufacturers.index'
import { Route as AuthenticatedLearnIndexRouteImport } from './routes/_authenticated/learn.index'
import { Route as AuthenticatedInvoicesIndexRouteImport } from './routes/_authenticated/invoices.index'
import { Route as AuthenticatedCustomersIndexRouteImport } from './routes/_authenticated/customers.index'
import { Route as AuthenticatedCustomerCommsIndexRouteImport } from './routes/_authenticated/customer-comms.index'
import { Route as AuthenticatedContactsIndexRouteImport } from './routes/_authenticated/contacts.index'
import { Route as AuthenticatedAiIndexRouteImport } from './routes/_authenticated/ai.index'
import { Route as AuthenticatedWarehouseLocationsRouteImport } from './routes/_authenticated/warehouse.locations'
import { Route as AuthenticatedWarehouseStockIdRouteImport } from './routes/_authenticated/warehouse.$stockId'
import { Route as AuthenticatedTaxExemptionsFormIdRouteImport } from './routes/_authenticated/tax-exemptions.$formId'
import { Route as AuthenticatedSuppliersSupplierIdRouteImport } from './routes/_authenticated/suppliers.$supplierId'
import { Route as AuthenticatedStaffDefaultsRouteImport } from './routes/_authenticated/staff.defaults'
import { Route as AuthenticatedStaffStaffIdRouteImport } from './routes/_authenticated/staff.$staffId'
import { Route as AuthenticatedShipmentsShipmentIdRouteImport } from './routes/_authenticated/shipments.$shipmentId'
import { Route as AuthenticatedReceivablesInvoiceIdRouteImport } from './routes/_authenticated/receivables.$invoiceId'
import { Route as AuthenticatedQuotesNewRouteImport } from './routes/_authenticated/quotes.new'
import { Route as AuthenticatedQuotesQuoteIdRouteImport } from './routes/_authenticated/quotes.$quoteId'
import { Route as AuthenticatedPurchaseOrdersPoIdRouteImport } from './routes/_authenticated/purchase-orders.$poId'
import { Route as AuthenticatedProjectsWaitingOnRouteImport } from './routes/_authenticated/projects.waiting-on'
import { Route as AuthenticatedProjectsTimelineRouteImport } from './routes/_authenticated/projects.timeline'
import { Route as AuthenticatedProjectsSalesOverviewRouteImport } from './routes/_authenticated/projects.sales-overview'
import { Route as AuthenticatedProjectsActionItemsRouteImport } from './routes/_authenticated/projects.action-items'
import { Route as AuthenticatedProjectsProjectIdRouteImport } from './routes/_authenticated/projects.$projectId'
import { Route as AuthenticatedProductsProductIdRouteImport } from './routes/_authenticated/products.$productId'
import { Route as AuthenticatedOrdersOrderIdRouteImport } from './routes/_authenticated/orders.$orderId'
import { Route as AuthenticatedOrderReviewFindingIdRouteImport } from './routes/_authenticated/order-review.$findingId'
import { Route as AuthenticatedManufacturersManuIdRouteImport } from './routes/_authenticated/manufacturers.$manuId'
import { Route as AuthenticatedLearnTeamRouteImport } from './routes/_authenticated/learn.team'
import { Route as AuthenticatedLearnLessonKeyRouteImport } from './routes/_authenticated/learn.$lessonKey'
import { Route as AuthenticatedInvoicesInvoiceIdRouteImport } from './routes/_authenticated/invoices.$invoiceId'
import { Route as AuthenticatedCustomersGroupIdRouteImport } from './routes/_authenticated/customers.$groupId'
import { Route as AuthenticatedCustomerCommsStoreAiRouteImport } from './routes/_authenticated/customer-comms.store-ai'
import { Route as AuthenticatedCustomerCommsThreadIdRouteImport } from './routes/_authenticated/customer-comms.$threadId'
import { Route as AuthenticatedContactsContactIdRouteImport } from './routes/_authenticated/contacts.$contactId'
import { Route as AuthenticatedApVendorsVendorIdRouteImport } from './routes/_authenticated/ap-vendors.$vendorId'
import { Route as AuthenticatedAiApiKeysRouteImport } from './routes/_authenticated/ai.api-keys'
import { Route as AuthenticatedAiAgentKeyRouteImport } from './routes/_authenticated/ai.$agentKey'
import { Route as AuthenticatedProjectsDropshipDraftsIndexRouteImport } from './routes/_authenticated/projects.dropship-drafts.index'
import { Route as AuthenticatedCustomerCommsStoreAiIndexRouteImport } from './routes/_authenticated/customer-comms.store-ai.index'
import { Route as AuthenticatedCustomerCommsChatsIndexRouteImport } from './routes/_authenticated/customer-comms.chats.index'
import { Route as AuthenticatedWarehouseItemProductIdRouteImport } from './routes/_authenticated/warehouse.item.$productId'
import { Route as AuthenticatedShippingCalculatorQuoteAttemptsAttemptIdRouteImport } from './routes/_authenticated/shipping-calculator.quote-attempts.$attemptId'
import { Route as AuthenticatedQuotesQuoteIdVersionsRouteImport } from './routes/_authenticated/quotes.$quoteId.versions'
import { Route as AuthenticatedQuotesQuoteIdShareRouteImport } from './routes/_authenticated/quotes.$quoteId.share'
import { Route as AuthenticatedQuotesQuoteIdEmailsRouteImport } from './routes/_authenticated/quotes.$quoteId.emails'
import { Route as AuthenticatedQuotesQuoteIdCommentsRouteImport } from './routes/_authenticated/quotes.$quoteId.comments'
import { Route as AuthenticatedProjectsDropshipDraftsDraftUuidRouteImport } from './routes/_authenticated/projects.dropship-drafts.$draftUuid'
import { Route as AuthenticatedCustomerCommsStoreAiChatIdRouteImport } from './routes/_authenticated/customer-comms.store-ai.$chatId'
import { Route as AuthenticatedCustomerCommsChatsConversationIdRouteImport } from './routes/_authenticated/customer-comms.chats.$conversationId'
import { Route as AuthenticatedQuotesQuoteIdWorkflowStageRouteImport } from './routes/_authenticated/quotes.$quoteId.workflow.$stage'
import { Route as AuthenticatedCustomersGroupIdCommsThreadIdRouteImport } from './routes/_authenticated/customers.$groupId_.comms.$threadId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWarrantyClaimsRoute =
  AuthenticatedWarrantyClaimsRouteImport.update({
    id: '/warranty-claims',
    path: '/warranty-claims',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWarehouseRoute = AuthenticatedWarehouseRouteImport.update({
  id: '/warehouse',
  path: '/warehouse',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTaxRatesRoute = AuthenticatedTaxRatesRouteImport.update({
  id: '/tax-rates',
  path: '/tax-rates',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTaxExemptionsRoute =
  AuthenticatedTaxExemptionsRouteImport.update({
    id: '/tax-exemptions',
    path: '/tax-exemptions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuppliersRoute = AuthenticatedSuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedStoreReadinessRoute =
  AuthenticatedStoreReadinessRouteImport.update({
    id: '/store-readiness',
    path: '/store-readiness',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStaffRoute = AuthenticatedStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSpecialsRoute = AuthenticatedSpecialsRouteImport.update({
  id: '/specials',
  path: '/specials',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSourcesRoute = AuthenticatedSourcesRouteImport.update({
  id: '/sources',
  path: '/sources',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedShippingCalculatorRoute =
  AuthenticatedShippingCalculatorRouteImport.update({
    id: '/shipping-calculator',
    path: '/shipping-calculator',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedShipmentsRoute = AuthenticatedShipmentsRouteImport.update({
  id: '/shipments',
  path: '/shipments',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReceivablesRoute =
  AuthenticatedReceivablesRouteImport.update({
    id: '/receivables',
    path: '/receivables',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedQuotesRoute = AuthenticatedQuotesRouteImport.update({
  id: '/quotes',
  path: '/quotes',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedQuotedVsActualRoute =
  AuthenticatedQuotedVsActualRouteImport.update({
    id: '/quoted-vs-actual',
    path: '/quoted-vs-actual',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedQualityTiersRoute =
  AuthenticatedQualityTiersRouteImport.update({
    id: '/quality-tiers',
    path: '/quality-tiers',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPurchaseOrdersRoute =
  AuthenticatedPurchaseOrdersRouteImport.update({
    id: '/purchase-orders',
    path: '/purchase-orders',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsRoute = AuthenticatedProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProductsRoute = AuthenticatedProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPriceMatchingRoute =
  AuthenticatedPriceMatchingRouteImport.update({
    id: '/price-matching',
    path: '/price-matching',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersRoute = AuthenticatedOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrderReviewRoute =
  AuthenticatedOrderReviewRouteImport.update({
    id: '/order-review',
    path: '/order-review',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedManufacturersRoute =
  AuthenticatedManufacturersRouteImport.update({
    id: '/manufacturers',
    path: '/manufacturers',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLearnRoute = AuthenticatedLearnRouteImport.update({
  id: '/learn',
  path: '/learn',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInvoicesRoute = AuthenticatedInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedE2eTestingRoute = AuthenticatedE2eTestingRouteImport.update({
  id: '/e2e-testing',
  path: '/e2e-testing',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCustomersRoute = AuthenticatedCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCustomerCommsRoute =
  AuthenticatedCustomerCommsRouteImport.update({
    id: '/customer-comms',
    path: '/customer-comms',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContactsRoute = AuthenticatedContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCompanyRoute = AuthenticatedCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCommunicationsRoute =
  AuthenticatedCommunicationsRouteImport.update({
    id: '/communications',
    path: '/communications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCatalogSourcesRoute =
  AuthenticatedCatalogSourcesRouteImport.update({
    id: '/catalog-sources',
    path: '/catalog-sources',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCatalogSearchRoute =
  AuthenticatedCatalogSearchRouteImport.update({
    id: '/catalog-search',
    path: '/catalog-search',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApVendorsRoute = AuthenticatedApVendorsRouteImport.update({
  id: '/ap-vendors',
  path: '/ap-vendors',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAnalyticsRoute = AuthenticatedAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAiCostsRoute = AuthenticatedAiCostsRouteImport.update({
  id: '/ai-costs',
  path: '/ai-costs',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAiRoute = AuthenticatedAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWarehouseIndexRoute =
  AuthenticatedWarehouseIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWarehouseRoute,
  } as any)
const AuthenticatedTaxExemptionsIndexRoute =
  AuthenticatedTaxExemptionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTaxExemptionsRoute,
  } as any)
const AuthenticatedSuppliersIndexRoute =
  AuthenticatedSuppliersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSuppliersRoute,
  } as any)
const AuthenticatedStaffIndexRoute = AuthenticatedStaffIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedStaffRoute,
} as any)
const AuthenticatedShippingCalculatorIndexRoute =
  AuthenticatedShippingCalculatorIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedShippingCalculatorRoute,
  } as any)
const AuthenticatedShipmentsIndexRoute =
  AuthenticatedShipmentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedShipmentsRoute,
  } as any)
const AuthenticatedReceivablesIndexRoute =
  AuthenticatedReceivablesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedReceivablesRoute,
  } as any)
const AuthenticatedQuotesIndexRoute =
  AuthenticatedQuotesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedQuotesRoute,
  } as any)
const AuthenticatedPurchaseOrdersIndexRoute =
  AuthenticatedPurchaseOrdersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPurchaseOrdersRoute,
  } as any)
const AuthenticatedProjectsIndexRoute =
  AuthenticatedProjectsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProjectsRoute,
  } as any)
const AuthenticatedProductsIndexRoute =
  AuthenticatedProductsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProductsRoute,
  } as any)
const AuthenticatedOrdersIndexRoute =
  AuthenticatedOrdersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrdersRoute,
  } as any)
const AuthenticatedOrderReviewIndexRoute =
  AuthenticatedOrderReviewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrderReviewRoute,
  } as any)
const AuthenticatedManufacturersIndexRoute =
  AuthenticatedManufacturersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedManufacturersRoute,
  } as any)
const AuthenticatedLearnIndexRoute = AuthenticatedLearnIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedLearnRoute,
} as any)
const AuthenticatedInvoicesIndexRoute =
  AuthenticatedInvoicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedCustomersIndexRoute =
  AuthenticatedCustomersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCustomersRoute,
  } as any)
const AuthenticatedCustomerCommsIndexRoute =
  AuthenticatedCustomerCommsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCustomerCommsRoute,
  } as any)
const AuthenticatedContactsIndexRoute =
  AuthenticatedContactsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedContactsRoute,
  } as any)
const AuthenticatedAiIndexRoute = AuthenticatedAiIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAiRoute,
} as any)
const AuthenticatedWarehouseLocationsRoute =
  AuthenticatedWarehouseLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AuthenticatedWarehouseRoute,
  } as any)
const AuthenticatedWarehouseStockIdRoute =
  AuthenticatedWarehouseStockIdRouteImport.update({
    id: '/$stockId',
    path: '/$stockId',
    getParentRoute: () => AuthenticatedWarehouseRoute,
  } as any)
const AuthenticatedTaxExemptionsFormIdRoute =
  AuthenticatedTaxExemptionsFormIdRouteImport.update({
    id: '/$formId',
    path: '/$formId',
    getParentRoute: () => AuthenticatedTaxExemptionsRoute,
  } as any)
const AuthenticatedSuppliersSupplierIdRoute =
  AuthenticatedSuppliersSupplierIdRouteImport.update({
    id: '/$supplierId',
    path: '/$supplierId',
    getParentRoute: () => AuthenticatedSuppliersRoute,
  } as any)
const AuthenticatedStaffDefaultsRoute =
  AuthenticatedStaffDefaultsRouteImport.update({
    id: '/defaults',
    path: '/defaults',
    getParentRoute: () => AuthenticatedStaffRoute,
  } as any)
const AuthenticatedStaffStaffIdRoute =
  AuthenticatedStaffStaffIdRouteImport.update({
    id: '/$staffId',
    path: '/$staffId',
    getParentRoute: () => AuthenticatedStaffRoute,
  } as any)
const AuthenticatedShipmentsShipmentIdRoute =
  AuthenticatedShipmentsShipmentIdRouteImport.update({
    id: '/$shipmentId',
    path: '/$shipmentId',
    getParentRoute: () => AuthenticatedShipmentsRoute,
  } as any)
const AuthenticatedReceivablesInvoiceIdRoute =
  AuthenticatedReceivablesInvoiceIdRouteImport.update({
    id: '/$invoiceId',
    path: '/$invoiceId',
    getParentRoute: () => AuthenticatedReceivablesRoute,
  } as any)
const AuthenticatedQuotesNewRoute = AuthenticatedQuotesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedQuotesRoute,
} as any)
const AuthenticatedQuotesQuoteIdRoute =
  AuthenticatedQuotesQuoteIdRouteImport.update({
    id: '/$quoteId',
    path: '/$quoteId',
    getParentRoute: () => AuthenticatedQuotesRoute,
  } as any)
const AuthenticatedPurchaseOrdersPoIdRoute =
  AuthenticatedPurchaseOrdersPoIdRouteImport.update({
    id: '/$poId',
    path: '/$poId',
    getParentRoute: () => AuthenticatedPurchaseOrdersRoute,
  } as any)
const AuthenticatedProjectsWaitingOnRoute =
  AuthenticatedProjectsWaitingOnRouteImport.update({
    id: '/waiting-on',
    path: '/waiting-on',
    getParentRoute: () => AuthenticatedProjectsRoute,
  } as any)
const AuthenticatedProjectsTimelineRoute =
  AuthenticatedProjectsTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => AuthenticatedProjectsRoute,
  } as any)
const AuthenticatedProjectsSalesOverviewRoute =
  AuthenticatedProjectsSalesOverviewRouteImport.update({
    id: '/sales-overview',
    path: '/sales-overview',
    getParentRoute: () => AuthenticatedProjectsRoute,
  } as any)
const AuthenticatedProjectsActionItemsRoute =
  AuthenticatedProjectsActionItemsRouteImport.update({
    id: '/action-items',
    path: '/action-items',
    getParentRoute: () => AuthenticatedProjectsRoute,
  } as any)
const AuthenticatedProjectsProjectIdRoute =
  AuthenticatedProjectsProjectIdRouteImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => AuthenticatedProjectsRoute,
  } as any)
const AuthenticatedProductsProductIdRoute =
  AuthenticatedProductsProductIdRouteImport.update({
    id: '/$productId',
    path: '/$productId',
    getParentRoute: () => AuthenticatedProductsRoute,
  } as any)
const AuthenticatedOrdersOrderIdRoute =
  AuthenticatedOrdersOrderIdRouteImport.update({
    id: '/$orderId',
    path: '/$orderId',
    getParentRoute: () => AuthenticatedOrdersRoute,
  } as any)
const AuthenticatedOrderReviewFindingIdRoute =
  AuthenticatedOrderReviewFindingIdRouteImport.update({
    id: '/$findingId',
    path: '/$findingId',
    getParentRoute: () => AuthenticatedOrderReviewRoute,
  } as any)
const AuthenticatedManufacturersManuIdRoute =
  AuthenticatedManufacturersManuIdRouteImport.update({
    id: '/$manuId',
    path: '/$manuId',
    getParentRoute: () => AuthenticatedManufacturersRoute,
  } as any)
const AuthenticatedLearnTeamRoute = AuthenticatedLearnTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthenticatedLearnRoute,
} as any)
const AuthenticatedLearnLessonKeyRoute =
  AuthenticatedLearnLessonKeyRouteImport.update({
    id: '/$lessonKey',
    path: '/$lessonKey',
    getParentRoute: () => AuthenticatedLearnRoute,
  } as any)
const AuthenticatedInvoicesInvoiceIdRoute =
  AuthenticatedInvoicesInvoiceIdRouteImport.update({
    id: '/$invoiceId',
    path: '/$invoiceId',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedCustomersGroupIdRoute =
  AuthenticatedCustomersGroupIdRouteImport.update({
    id: '/$groupId',
    path: '/$groupId',
    getParentRoute: () => AuthenticatedCustomersRoute,
  } as any)
const AuthenticatedCustomerCommsStoreAiRoute =
  AuthenticatedCustomerCommsStoreAiRouteImport.update({
    id: '/store-ai',
    path: '/store-ai',
    getParentRoute: () => AuthenticatedCustomerCommsRoute,
  } as any)
const AuthenticatedCustomerCommsThreadIdRoute =
  AuthenticatedCustomerCommsThreadIdRouteImport.update({
    id: '/$threadId',
    path: '/$threadId',
    getParentRoute: () => AuthenticatedCustomerCommsRoute,
  } as any)
const AuthenticatedContactsContactIdRoute =
  AuthenticatedContactsContactIdRouteImport.update({
    id: '/$contactId',
    path: '/$contactId',
    getParentRoute: () => AuthenticatedContactsRoute,
  } as any)
const AuthenticatedApVendorsVendorIdRoute =
  AuthenticatedApVendorsVendorIdRouteImport.update({
    id: '/$vendorId',
    path: '/$vendorId',
    getParentRoute: () => AuthenticatedApVendorsRoute,
  } as any)
const AuthenticatedAiApiKeysRoute = AuthenticatedAiApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AuthenticatedAiRoute,
} as any)
const AuthenticatedAiAgentKeyRoute = AuthenticatedAiAgentKeyRouteImport.update({
  id: '/$agentKey',
  path: '/$agentKey',
  getParentRoute: () => AuthenticatedAiRoute,
} as any)
const AuthenticatedProjectsDropshipDraftsIndexRoute =
  AuthenticatedProjectsDropshipDraftsIndexRouteImport.update({
    id: '/dropship-drafts/',
    path: '/dropship-drafts/',
    getParentRoute: () => AuthenticatedProjectsRoute,
  } as any)
const AuthenticatedCustomerCommsStoreAiIndexRoute =
  AuthenticatedCustomerCommsStoreAiIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCustomerCommsStoreAiRoute,
  } as any)
const AuthenticatedCustomerCommsChatsIndexRoute =
  AuthenticatedCustomerCommsChatsIndexRouteImport.update({
    id: '/chats/',
    path: '/chats/',
    getParentRoute: () => AuthenticatedCustomerCommsRoute,
  } as any)
const AuthenticatedWarehouseItemProductIdRoute =
  AuthenticatedWarehouseItemProductIdRouteImport.update({
    id: '/item/$productId',
    path: '/item/$productId',
    getParentRoute: () => AuthenticatedWarehouseRoute,
  } as any)
const AuthenticatedShippingCalculatorQuoteAttemptsAttemptIdRoute =
  AuthenticatedShippingCalculatorQuoteAttemptsAttemptIdRouteImport.update({
    id: '/quote-attempts/$attemptId',
    path: '/quote-attempts/$attemptId',
    getParentRoute: () => AuthenticatedShippingCalculatorRoute,
  } as any)
const AuthenticatedQuotesQuoteIdVersionsRoute =
  AuthenticatedQuotesQuoteIdVersionsRouteImport.update({
    id: '/versions',
    path: '/versions',
    getParentRoute: () => AuthenticatedQuotesQuoteIdRoute,
  } as any)
const AuthenticatedQuotesQuoteIdShareRoute =
  AuthenticatedQuotesQuoteIdShareRouteImport.update({
    id: '/share',
    path: '/share',
    getParentRoute: () => AuthenticatedQuotesQuoteIdRoute,
  } as any)
const AuthenticatedQuotesQuoteIdEmailsRoute =
  AuthenticatedQuotesQuoteIdEmailsRouteImport.update({
    id: '/emails',
    path: '/emails',
    getParentRoute: () => AuthenticatedQuotesQuoteIdRoute,
  } as any)
const AuthenticatedQuotesQuoteIdCommentsRoute =
  AuthenticatedQuotesQuoteIdCommentsRouteImport.update({
    id: '/comments',
    path: '/comments',
    getParentRoute: () => AuthenticatedQuotesQuoteIdRoute,
  } as any)
const AuthenticatedProjectsDropshipDraftsDraftUuidRoute =
  AuthenticatedProjectsDropshipDraftsDraftUuidRouteImport.update({
    id: '/dropship-drafts/$draftUuid',
    path: '/dropship-drafts/$draftUuid',
    getParentRoute: () => AuthenticatedProjectsRoute,
  } as any)
const AuthenticatedCustomerCommsStoreAiChatIdRoute =
  AuthenticatedCustomerCommsStoreAiChatIdRouteImport.update({
    id: '/$chatId',
    path: '/$chatId',
    getParentRoute: () => AuthenticatedCustomerCommsStoreAiRoute,
  } as any)
const AuthenticatedCustomerCommsChatsConversationIdRoute =
  AuthenticatedCustomerCommsChatsConversationIdRouteImport.update({
    id: '/chats/$conversationId',
    path: '/chats/$conversationId',
    getParentRoute: () => AuthenticatedCustomerCommsRoute,
  } as any)
const AuthenticatedQuotesQuoteIdWorkflowStageRoute =
  AuthenticatedQuotesQuoteIdWorkflowStageRouteImport.update({
    id: '/workflow/$stage',
    path: '/workflow/$stage',
    getParentRoute: () => AuthenticatedQuotesQuoteIdRoute,
  } as any)
const AuthenticatedCustomersGroupIdCommsThreadIdRoute =
  AuthenticatedCustomersGroupIdCommsThreadIdRouteImport.update({
    id: '/$groupId_/comms/$threadId',
    path: '/$groupId/comms/$threadId',
    getParentRoute: () => AuthenticatedCustomersRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/ai': typeof AuthenticatedAiRouteWithChildren
  '/ai-costs': typeof AuthenticatedAiCostsRoute
  '/analytics': typeof AuthenticatedAnalyticsRoute
  '/ap-vendors': typeof AuthenticatedApVendorsRouteWithChildren
  '/catalog-search': typeof AuthenticatedCatalogSearchRoute
  '/catalog-sources': typeof AuthenticatedCatalogSourcesRoute
  '/communications': typeof AuthenticatedCommunicationsRoute
  '/company': typeof AuthenticatedCompanyRoute
  '/contacts': typeof AuthenticatedContactsRouteWithChildren
  '/customer-comms': typeof AuthenticatedCustomerCommsRouteWithChildren
  '/customers': typeof AuthenticatedCustomersRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/e2e-testing': typeof AuthenticatedE2eTestingRoute
  '/invoices': typeof AuthenticatedInvoicesRouteWithChildren
  '/learn': typeof AuthenticatedLearnRouteWithChildren
  '/manufacturers': typeof AuthenticatedManufacturersRouteWithChildren
  '/order-review': typeof AuthenticatedOrderReviewRouteWithChildren
  '/orders': typeof AuthenticatedOrdersRouteWithChildren
  '/price-matching': typeof AuthenticatedPriceMatchingRoute
  '/products': typeof AuthenticatedProductsRouteWithChildren
  '/projects': typeof AuthenticatedProjectsRouteWithChildren
  '/purchase-orders': typeof AuthenticatedPurchaseOrdersRouteWithChildren
  '/quality-tiers': typeof AuthenticatedQualityTiersRoute
  '/quoted-vs-actual': typeof AuthenticatedQuotedVsActualRoute
  '/quotes': typeof AuthenticatedQuotesRouteWithChildren
  '/receivables': typeof AuthenticatedReceivablesRouteWithChildren
  '/shipments': typeof AuthenticatedShipmentsRouteWithChildren
  '/shipping-calculator': typeof AuthenticatedShippingCalculatorRouteWithChildren
  '/sources': typeof AuthenticatedSourcesRoute
  '/specials': typeof AuthenticatedSpecialsRoute
  '/staff': typeof AuthenticatedStaffRouteWithChildren
  '/store-readiness': typeof AuthenticatedStoreReadinessRoute
  '/suppliers': typeof AuthenticatedSuppliersRouteWithChildren
  '/tax-exemptions': typeof AuthenticatedTaxExemptionsRouteWithChildren
  '/tax-rates': typeof AuthenticatedTaxRatesRoute
  '/warehouse': typeof AuthenticatedWarehouseRouteWithChildren
  '/warranty-claims': typeof AuthenticatedWarrantyClaimsRoute
  '/ai/$agentKey': typeof AuthenticatedAiAgentKeyRoute
  '/ai/api-keys': typeof AuthenticatedAiApiKeysRoute
  '/ap-vendors/$vendorId': typeof AuthenticatedApVendorsVendorIdRoute
  '/contacts/$contactId': typeof AuthenticatedContactsContactIdRoute
  '/customer-comms/$threadId': typeof AuthenticatedCustomerCommsThreadIdRoute
  '/customer-comms/store-ai': typeof AuthenticatedCustomerCommsStoreAiRouteWithChildren
  '/customers/$groupId': typeof AuthenticatedCustomersGroupIdRoute
  '/invoices/$invoiceId': typeof AuthenticatedInvoicesInvoiceIdRoute
  '/learn/$lessonKey': typeof AuthenticatedLearnLessonKeyRoute
  '/learn/team': typeof AuthenticatedLearnTeamRoute
  '/manufacturers/$manuId': typeof AuthenticatedManufacturersManuIdRoute
  '/order-review/$findingId': typeof AuthenticatedOrderReviewFindingIdRoute
  '/orders/$orderId': typeof AuthenticatedOrdersOrderIdRoute
  '/products/$productId': typeof AuthenticatedProductsProductIdRoute
  '/projects/$projectId': typeof AuthenticatedProjectsProjectIdRoute
  '/projects/action-items': typeof AuthenticatedProjectsActionItemsRoute
  '/projects/sales-overview': typeof AuthenticatedProjectsSalesOverviewRoute
  '/projects/timeline': typeof AuthenticatedProjectsTimelineRoute
  '/projects/waiting-on': typeof AuthenticatedProjectsWaitingOnRoute
  '/purchase-orders/$poId': typeof AuthenticatedPurchaseOrdersPoIdRoute
  '/quotes/$quoteId': typeof AuthenticatedQuotesQuoteIdRouteWithChildren
  '/quotes/new': typeof AuthenticatedQuotesNewRoute
  '/receivables/$invoiceId': typeof AuthenticatedReceivablesInvoiceIdRoute
  '/shipments/$shipmentId': typeof AuthenticatedShipmentsShipmentIdRoute
  '/staff/$staffId': typeof AuthenticatedStaffStaffIdRoute
  '/staff/defaults': typeof AuthenticatedStaffDefaultsRoute
  '/suppliers/$supplierId': typeof AuthenticatedSuppliersSupplierIdRoute
  '/tax-exemptions/$formId': typeof AuthenticatedTaxExemptionsFormIdRoute
  '/warehouse/$stockId': typeof AuthenticatedWarehouseStockIdRoute
  '/warehouse/locations': typeof AuthenticatedWarehouseLocationsRoute
  '/ai/': typeof AuthenticatedAiIndexRoute
  '/contacts/': typeof AuthenticatedContactsIndexRoute
  '/customer-comms/': typeof AuthenticatedCustomerCommsIndexRoute
  '/customers/': typeof AuthenticatedCustomersIndexRoute
  '/invoices/': typeof AuthenticatedInvoicesIndexRoute
  '/learn/': typeof AuthenticatedLearnIndexRoute
  '/manufacturers/': typeof AuthenticatedManufacturersIndexRoute
  '/order-review/': typeof AuthenticatedOrderReviewIndexRoute
  '/orders/': typeof AuthenticatedOrdersIndexRoute
  '/products/': typeof AuthenticatedProductsIndexRoute
  '/projects/': typeof AuthenticatedProjectsIndexRoute
  '/purchase-orders/': typeof AuthenticatedPurchaseOrdersIndexRoute
  '/quotes/': typeof AuthenticatedQuotesIndexRoute
  '/receivables/': typeof AuthenticatedReceivablesIndexRoute
  '/shipments/': typeof AuthenticatedShipmentsIndexRoute
  '/shipping-calculator/': typeof AuthenticatedShippingCalculatorIndexRoute
  '/staff/': typeof AuthenticatedStaffIndexRoute
  '/suppliers/': typeof AuthenticatedSuppliersIndexRoute
  '/tax-exemptions/': typeof AuthenticatedTaxExemptionsIndexRoute
  '/warehouse/': typeof AuthenticatedWarehouseIndexRoute
  '/customer-comms/chats/$conversationId': typeof AuthenticatedCustomerCommsChatsConversationIdRoute
  '/customer-comms/store-ai/$chatId': typeof AuthenticatedCustomerCommsStoreAiChatIdRoute
  '/projects/dropship-drafts/$draftUuid': typeof AuthenticatedProjectsDropshipDraftsDraftUuidRoute
  '/quotes/$quoteId/comments': typeof AuthenticatedQuotesQuoteIdCommentsRoute
  '/quotes/$quoteId/emails': typeof AuthenticatedQuotesQuoteIdEmailsRoute
  '/quotes/$quoteId/share': typeof AuthenticatedQuotesQuoteIdShareRoute
  '/quotes/$quoteId/versions': typeof AuthenticatedQuotesQuoteIdVersionsRoute
  '/shipping-calculator/quote-attempts/$attemptId': typeof AuthenticatedShippingCalculatorQuoteAttemptsAttemptIdRoute
  '/warehouse/item/$productId': typeof AuthenticatedWarehouseItemProductIdRoute
  '/customer-comms/chats/': typeof AuthenticatedCustomerCommsChatsIndexRoute
  '/customer-comms/store-ai/': typeof AuthenticatedCustomerCommsStoreAiIndexRoute
  '/projects/dropship-drafts/': typeof AuthenticatedProjectsDropshipDraftsIndexRoute
  '/customers/$groupId/comms/$threadId': typeof AuthenticatedCustomersGroupIdCommsThreadIdRoute
  '/quotes/$quoteId/workflow/$stage': typeof AuthenticatedQuotesQuoteIdWorkflowStageRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/ai-costs': typeof AuthenticatedAiCostsRoute
  '/analytics': typeof AuthenticatedAnalyticsRoute
  '/ap-vendors': typeof AuthenticatedApVendorsRouteWithChildren
  '/catalog-search': typeof AuthenticatedCatalogSearchRoute
  '/catalog-sources': typeof AuthenticatedCatalogSourcesRoute
  '/communications': typeof AuthenticatedCommunicationsRoute
  '/company': typeof AuthenticatedCompanyRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/e2e-testing': typeof AuthenticatedE2eTestingRoute
  '/price-matching': typeof AuthenticatedPriceMatchingRoute
  '/quality-tiers': typeof AuthenticatedQualityTiersRoute
  '/quoted-vs-actual': typeof AuthenticatedQuotedVsActualRoute
  '/sources': typeof AuthenticatedSourcesRoute
  '/specials': typeof AuthenticatedSpecialsRoute
  '/store-readiness': typeof AuthenticatedStoreReadinessRoute
  '/tax-rates': typeof AuthenticatedTaxRatesRoute
  '/warranty-claims': typeof AuthenticatedWarrantyClaimsRoute
  '/ai/$agentKey': typeof AuthenticatedAiAgentKeyRoute
  '/ai/api-keys': typeof AuthenticatedAiApiKeysRoute
  '/ap-vendors/$vendorId': typeof AuthenticatedApVendorsVendorIdRoute
  '/contacts/$contactId': typeof AuthenticatedContactsContactIdRoute
  '/customer-comms/$threadId': typeof AuthenticatedCustomerCommsThreadIdRoute
  '/customers/$groupId': typeof AuthenticatedCustomersGroupIdRoute
  '/invoices/$invoiceId': typeof AuthenticatedInvoicesInvoiceIdRoute
  '/learn/$lessonKey': typeof AuthenticatedLearnLessonKeyRoute
  '/learn/team': typeof AuthenticatedLearnTeamRoute
  '/manufacturers/$manuId': typeof AuthenticatedManufacturersManuIdRoute
  '/order-review/$findingId': typeof AuthenticatedOrderReviewFindingIdRoute
  '/orders/$orderId': typeof AuthenticatedOrdersOrderIdRoute
  '/products/$productId': typeof AuthenticatedProductsProductIdRoute
  '/projects/$projectId': typeof AuthenticatedProjectsProjectIdRoute
  '/projects/action-items': typeof AuthenticatedProjectsActionItemsRoute
  '/projects/sales-overview': typeof AuthenticatedProjectsSalesOverviewRoute
  '/projects/timeline': typeof AuthenticatedProjectsTimelineRoute
  '/projects/waiting-on': typeof AuthenticatedProjectsWaitingOnRoute
  '/purchase-orders/$poId': typeof AuthenticatedPurchaseOrdersPoIdRoute
  '/quotes/$quoteId': typeof AuthenticatedQuotesQuoteIdRouteWithChildren
  '/quotes/new': typeof AuthenticatedQuotesNewRoute
  '/receivables/$invoiceId': typeof AuthenticatedReceivablesInvoiceIdRoute
  '/shipments/$shipmentId': typeof AuthenticatedShipmentsShipmentIdRoute
  '/staff/$staffId': typeof AuthenticatedStaffStaffIdRoute
  '/staff/defaults': typeof AuthenticatedStaffDefaultsRoute
  '/suppliers/$supplierId': typeof AuthenticatedSuppliersSupplierIdRoute
  '/tax-exemptions/$formId': typeof AuthenticatedTaxExemptionsFormIdRoute
  '/warehouse/$stockId': typeof AuthenticatedWarehouseStockIdRoute
  '/warehouse/locations': typeof AuthenticatedWarehouseLocationsRoute
  '/ai': typeof AuthenticatedAiIndexRoute
  '/contacts': typeof AuthenticatedContactsIndexRoute
  '/customer-comms': typeof AuthenticatedCustomerCommsIndexRoute
  '/customers': typeof AuthenticatedCustomersIndexRoute
  '/invoices': typeof AuthenticatedInvoicesIndexRoute
  '/learn': typeof AuthenticatedLearnIndexRoute
  '/manufacturers': typeof AuthenticatedManufacturersIndexRoute
  '/order-review': typeof AuthenticatedOrderReviewIndexRoute
  '/orders': typeof AuthenticatedOrdersIndexRoute
  '/products': typeof AuthenticatedProductsIndexRoute
  '/projects': typeof AuthenticatedProjectsIndexRoute
  '/purchase-orders': typeof AuthenticatedPurchaseOrdersIndexRoute
  '/quotes': typeof AuthenticatedQuotesIndexRoute
  '/receivables': typeof AuthenticatedReceivablesIndexRoute
  '/shipments': typeof AuthenticatedShipmentsIndexRoute
  '/shipping-calculator': typeof AuthenticatedShippingCalculatorIndexRoute
  '/staff': typeof AuthenticatedStaffIndexRoute
  '/suppliers': typeof AuthenticatedSuppliersIndexRoute
  '/tax-exemptions': typeof AuthenticatedTaxExemptionsIndexRoute
  '/warehouse': typeof AuthenticatedWarehouseIndexRoute
  '/customer-comms/chats/$conversationId': typeof AuthenticatedCustomerCommsChatsConversationIdRoute
  '/customer-comms/store-ai/$chatId': typeof AuthenticatedCustomerCommsStoreAiChatIdRoute
  '/projects/dropship-drafts/$draftUuid': typeof AuthenticatedProjectsDropshipDraftsDraftUuidRoute
  '/quotes/$quoteId/comments': typeof AuthenticatedQuotesQuoteIdCommentsRoute
  '/quotes/$quoteId/emails': typeof AuthenticatedQuotesQuoteIdEmailsRoute
  '/quotes/$quoteId/share': typeof AuthenticatedQuotesQuoteIdShareRoute
  '/quotes/$quoteId/versions': typeof AuthenticatedQuotesQuoteIdVersionsRoute
  '/shipping-calculator/quote-attempts/$attemptId': typeof AuthenticatedShippingCalculatorQuoteAttemptsAttemptIdRoute
  '/warehouse/item/$productId': typeof AuthenticatedWarehouseItemProductIdRoute
  '/customer-comms/chats': typeof AuthenticatedCustomerCommsChatsIndexRoute
  '/customer-comms/store-ai': typeof AuthenticatedCustomerCommsStoreAiIndexRoute
  '/projects/dropship-drafts': typeof AuthenticatedProjectsDropshipDraftsIndexRoute
  '/customers/$groupId/comms/$threadId': typeof AuthenticatedCustomersGroupIdCommsThreadIdRoute
  '/quotes/$quoteId/workflow/$stage': typeof AuthenticatedQuotesQuoteIdWorkflowStageRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/_authenticated/ai': typeof AuthenticatedAiRouteWithChildren
  '/_authenticated/ai-costs': typeof AuthenticatedAiCostsRoute
  '/_authenticated/analytics': typeof AuthenticatedAnalyticsRoute
  '/_authenticated/ap-vendors': typeof AuthenticatedApVendorsRouteWithChildren
  '/_authenticated/catalog-search': typeof AuthenticatedCatalogSearchRoute
  '/_authenticated/catalog-sources': typeof AuthenticatedCatalogSourcesRoute
  '/_authenticated/communications': typeof AuthenticatedCommunicationsRoute
  '/_authenticated/company': typeof AuthenticatedCompanyRoute
  '/_authenticated/contacts': typeof AuthenticatedContactsRouteWithChildren
  '/_authenticated/customer-comms': typeof AuthenticatedCustomerCommsRouteWithChildren
  '/_authenticated/customers': typeof AuthenticatedCustomersRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/e2e-testing': typeof AuthenticatedE2eTestingRoute
  '/_authenticated/invoices': typeof AuthenticatedInvoicesRouteWithChildren
  '/_authenticated/learn': typeof AuthenticatedLearnRouteWithChildren
  '/_authenticated/manufacturers': typeof AuthenticatedManufacturersRouteWithChildren
  '/_authenticated/order-review': typeof AuthenticatedOrderReviewRouteWithChildren
  '/_authenticated/orders': typeof AuthenticatedOrdersRouteWithChildren
  '/_authenticated/price-matching': typeof AuthenticatedPriceMatchingRoute
  '/_authenticated/products': typeof AuthenticatedProductsRouteWithChildren
  '/_authenticated/projects': typeof AuthenticatedProjectsRouteWithChildren
  '/_authenticated/purchase-orders': typeof AuthenticatedPurchaseOrdersRouteWithChildren
  '/_authenticated/quality-tiers': typeof AuthenticatedQualityTiersRoute
  '/_authenticated/quoted-vs-actual': typeof AuthenticatedQuotedVsActualRoute
  '/_authenticated/quotes': typeof AuthenticatedQuotesRouteWithChildren
  '/_authenticated/receivables': typeof AuthenticatedReceivablesRouteWithChildren
  '/_authenticated/shipments': typeof AuthenticatedShipmentsRouteWithChildren
  '/_authenticated/shipping-calculator': typeof AuthenticatedShippingCalculatorRouteWithChildren
  '/_authenticated/sources': typeof AuthenticatedSourcesRoute
  '/_authenticated/specials': typeof AuthenticatedSpecialsRoute
  '/_authenticated/staff': typeof AuthenticatedStaffRouteWithChildren
  '/_authenticated/store-readiness': typeof AuthenticatedStoreReadinessRoute
  '/_authenticated/suppliers': typeof AuthenticatedSuppliersRouteWithChildren
  '/_authenticated/tax-exemptions': typeof AuthenticatedTaxExemptionsRouteWithChildren
  '/_authenticated/tax-rates': typeof AuthenticatedTaxRatesRoute
  '/_authenticated/warehouse': typeof AuthenticatedWarehouseRouteWithChildren
  '/_authenticated/warranty-claims': typeof AuthenticatedWarrantyClaimsRoute
  '/_authenticated/ai/$agentKey': typeof AuthenticatedAiAgentKeyRoute
  '/_authenticated/ai/api-keys': typeof AuthenticatedAiApiKeysRoute
  '/_authenticated/ap-vendors/$vendorId': typeof AuthenticatedApVendorsVendorIdRoute
  '/_authenticated/contacts/$contactId': typeof AuthenticatedContactsContactIdRoute
  '/_authenticated/customer-comms/$threadId': typeof AuthenticatedCustomerCommsThreadIdRoute
  '/_authenticated/customer-comms/store-ai': typeof AuthenticatedCustomerCommsStoreAiRouteWithChildren
  '/_authenticated/customers/$groupId': typeof AuthenticatedCustomersGroupIdRoute
  '/_authenticated/invoices/$invoiceId': typeof AuthenticatedInvoicesInvoiceIdRoute
  '/_authenticated/learn/$lessonKey': typeof AuthenticatedLearnLessonKeyRoute
  '/_authenticated/learn/team': typeof AuthenticatedLearnTeamRoute
  '/_authenticated/manufacturers/$manuId': typeof AuthenticatedManufacturersManuIdRoute
  '/_authenticated/order-review/$findingId': typeof AuthenticatedOrderReviewFindingIdRoute
  '/_authenticated/orders/$orderId': typeof AuthenticatedOrdersOrderIdRoute
  '/_authenticated/products/$productId': typeof AuthenticatedProductsProductIdRoute
  '/_authenticated/projects/$projectId': typeof AuthenticatedProjectsProjectIdRoute
  '/_authenticated/projects/action-items': typeof AuthenticatedProjectsActionItemsRoute
  '/_authenticated/projects/sales-overview': typeof AuthenticatedProjectsSalesOverviewRoute
  '/_authenticated/projects/timeline': typeof AuthenticatedProjectsTimelineRoute
  '/_authenticated/projects/waiting-on': typeof AuthenticatedProjectsWaitingOnRoute
  '/_authenticated/purchase-orders/$poId': typeof AuthenticatedPurchaseOrdersPoIdRoute
  '/_authenticated/quotes/$quoteId': typeof AuthenticatedQuotesQuoteIdRouteWithChildren
  '/_authenticated/quotes/new': typeof AuthenticatedQuotesNewRoute
  '/_authenticated/receivables/$invoiceId': typeof AuthenticatedReceivablesInvoiceIdRoute
  '/_authenticated/shipments/$shipmentId': typeof AuthenticatedShipmentsShipmentIdRoute
  '/_authenticated/staff/$staffId': typeof AuthenticatedStaffStaffIdRoute
  '/_authenticated/staff/defaults': typeof AuthenticatedStaffDefaultsRoute
  '/_authenticated/suppliers/$supplierId': typeof AuthenticatedSuppliersSupplierIdRoute
  '/_authenticated/tax-exemptions/$formId': typeof AuthenticatedTaxExemptionsFormIdRoute
  '/_authenticated/warehouse/$stockId': typeof AuthenticatedWarehouseStockIdRoute
  '/_authenticated/warehouse/locations': typeof AuthenticatedWarehouseLocationsRoute
  '/_authenticated/ai/': typeof AuthenticatedAiIndexRoute
  '/_authenticated/contacts/': typeof AuthenticatedContactsIndexRoute
  '/_authenticated/customer-comms/': typeof AuthenticatedCustomerCommsIndexRoute
  '/_authenticated/customers/': typeof AuthenticatedCustomersIndexRoute
  '/_authenticated/invoices/': typeof AuthenticatedInvoicesIndexRoute
  '/_authenticated/learn/': typeof AuthenticatedLearnIndexRoute
  '/_authenticated/manufacturers/': typeof AuthenticatedManufacturersIndexRoute
  '/_authenticated/order-review/': typeof AuthenticatedOrderReviewIndexRoute
  '/_authenticated/orders/': typeof AuthenticatedOrdersIndexRoute
  '/_authenticated/products/': typeof AuthenticatedProductsIndexRoute
  '/_authenticated/projects/': typeof AuthenticatedProjectsIndexRoute
  '/_authenticated/purchase-orders/': typeof AuthenticatedPurchaseOrdersIndexRoute
  '/_authenticated/quotes/': typeof AuthenticatedQuotesIndexRoute
  '/_authenticated/receivables/': typeof AuthenticatedReceivablesIndexRoute
  '/_authenticated/shipments/': typeof AuthenticatedShipmentsIndexRoute
  '/_authenticated/shipping-calculator/': typeof AuthenticatedShippingCalculatorIndexRoute
  '/_authenticated/staff/': typeof AuthenticatedStaffIndexRoute
  '/_authenticated/suppliers/': typeof AuthenticatedSuppliersIndexRoute
  '/_authenticated/tax-exemptions/': typeof AuthenticatedTaxExemptionsIndexRoute
  '/_authenticated/warehouse/': typeof AuthenticatedWarehouseIndexRoute
  '/_authenticated/customer-comms/chats/$conversationId': typeof AuthenticatedCustomerCommsChatsConversationIdRoute
  '/_authenticated/customer-comms/store-ai/$chatId': typeof AuthenticatedCustomerCommsStoreAiChatIdRoute
  '/_authenticated/projects/dropship-drafts/$draftUuid': typeof AuthenticatedProjectsDropshipDraftsDraftUuidRoute
  '/_authenticated/quotes/$quoteId/comments': typeof AuthenticatedQuotesQuoteIdCommentsRoute
  '/_authenticated/quotes/$quoteId/emails': typeof AuthenticatedQuotesQuoteIdEmailsRoute
  '/_authenticated/quotes/$quoteId/share': typeof AuthenticatedQuotesQuoteIdShareRoute
  '/_authenticated/quotes/$quoteId/versions': typeof AuthenticatedQuotesQuoteIdVersionsRoute
  '/_authenticated/shipping-calculator/quote-attempts/$attemptId': typeof AuthenticatedShippingCalculatorQuoteAttemptsAttemptIdRoute
  '/_authenticated/warehouse/item/$productId': typeof AuthenticatedWarehouseItemProductIdRoute
  '/_authenticated/customer-comms/chats/': typeof AuthenticatedCustomerCommsChatsIndexRoute
  '/_authenticated/customer-comms/store-ai/': typeof AuthenticatedCustomerCommsStoreAiIndexRoute
  '/_authenticated/projects/dropship-drafts/': typeof AuthenticatedProjectsDropshipDraftsIndexRoute
  '/_authenticated/customers/$groupId_/comms/$threadId': typeof AuthenticatedCustomersGroupIdCommsThreadIdRoute
  '/_authenticated/quotes/$quoteId/workflow/$stage': typeof AuthenticatedQuotesQuoteIdWorkflowStageRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/login'
    | '/ai'
    | '/ai-costs'
    | '/analytics'
    | '/ap-vendors'
    | '/catalog-search'
    | '/catalog-sources'
    | '/communications'
    | '/company'
    | '/contacts'
    | '/customer-comms'
    | '/customers'
    | '/dashboard'
    | '/e2e-testing'
    | '/invoices'
    | '/learn'
    | '/manufacturers'
    | '/order-review'
    | '/orders'
    | '/price-matching'
    | '/products'
    | '/projects'
    | '/purchase-orders'
    | '/quality-tiers'
    | '/quoted-vs-actual'
    | '/quotes'
    | '/receivables'
    | '/shipments'
    | '/shipping-calculator'
    | '/sources'
    | '/specials'
    | '/staff'
    | '/store-readiness'
    | '/suppliers'
    | '/tax-exemptions'
    | '/tax-rates'
    | '/warehouse'
    | '/warranty-claims'
    | '/ai/$agentKey'
    | '/ai/api-keys'
    | '/ap-vendors/$vendorId'
    | '/contacts/$contactId'
    | '/customer-comms/$threadId'
    | '/customer-comms/store-ai'
    | '/customers/$groupId'
    | '/invoices/$invoiceId'
    | '/learn/$lessonKey'
    | '/learn/team'
    | '/manufacturers/$manuId'
    | '/order-review/$findingId'
    | '/orders/$orderId'
    | '/products/$productId'
    | '/projects/$projectId'
    | '/projects/action-items'
    | '/projects/sales-overview'
    | '/projects/timeline'
    | '/projects/waiting-on'
    | '/purchase-orders/$poId'
    | '/quotes/$quoteId'
    | '/quotes/new'
    | '/receivables/$invoiceId'
    | '/shipments/$shipmentId'
    | '/staff/$staffId'
    | '/staff/defaults'
    | '/suppliers/$supplierId'
    | '/tax-exemptions/$formId'
    | '/warehouse/$stockId'
    | '/warehouse/locations'
    | '/ai/'
    | '/contacts/'
    | '/customer-comms/'
    | '/customers/'
    | '/invoices/'
    | '/learn/'
    | '/manufacturers/'
    | '/order-review/'
    | '/orders/'
    | '/products/'
    | '/projects/'
    | '/purchase-orders/'
    | '/quotes/'
    | '/receivables/'
    | '/shipments/'
    | '/shipping-calculator/'
    | '/staff/'
    | '/suppliers/'
    | '/tax-exemptions/'
    | '/warehouse/'
    | '/customer-comms/chats/$conversationId'
    | '/customer-comms/store-ai/$chatId'
    | '/projects/dropship-drafts/$draftUuid'
    | '/quotes/$quoteId/comments'
    | '/quotes/$quoteId/emails'
    | '/quotes/$quoteId/share'
    | '/quotes/$quoteId/versions'
    | '/shipping-calculator/quote-attempts/$attemptId'
    | '/warehouse/item/$productId'
    | '/customer-comms/chats/'
    | '/customer-comms/store-ai/'
    | '/projects/dropship-drafts/'
    | '/customers/$groupId/comms/$threadId'
    | '/quotes/$quoteId/workflow/$stage'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/callback'
    | '/login'
    | '/ai-costs'
    | '/analytics'
    | '/ap-vendors'
    | '/catalog-search'
    | '/catalog-sources'
    | '/communications'
    | '/company'
    | '/dashboard'
    | '/e2e-testing'
    | '/price-matching'
    | '/quality-tiers'
    | '/quoted-vs-actual'
    | '/sources'
    | '/specials'
    | '/store-readiness'
    | '/tax-rates'
    | '/warranty-claims'
    | '/ai/$agentKey'
    | '/ai/api-keys'
    | '/ap-vendors/$vendorId'
    | '/contacts/$contactId'
    | '/customer-comms/$threadId'
    | '/customers/$groupId'
    | '/invoices/$invoiceId'
    | '/learn/$lessonKey'
    | '/learn/team'
    | '/manufacturers/$manuId'
    | '/order-review/$findingId'
    | '/orders/$orderId'
    | '/products/$productId'
    | '/projects/$projectId'
    | '/projects/action-items'
    | '/projects/sales-overview'
    | '/projects/timeline'
    | '/projects/waiting-on'
    | '/purchase-orders/$poId'
    | '/quotes/$quoteId'
    | '/quotes/new'
    | '/receivables/$invoiceId'
    | '/shipments/$shipmentId'
    | '/staff/$staffId'
    | '/staff/defaults'
    | '/suppliers/$supplierId'
    | '/tax-exemptions/$formId'
    | '/warehouse/$stockId'
    | '/warehouse/locations'
    | '/ai'
    | '/contacts'
    | '/customer-comms'
    | '/customers'
    | '/invoices'
    | '/learn'
    | '/manufacturers'
    | '/order-review'
    | '/orders'
    | '/products'
    | '/projects'
    | '/purchase-orders'
    | '/quotes'
    | '/receivables'
    | '/shipments'
    | '/shipping-calculator'
    | '/staff'
    | '/suppliers'
    | '/tax-exemptions'
    | '/warehouse'
    | '/customer-comms/chats/$conversationId'
    | '/customer-comms/store-ai/$chatId'
    | '/projects/dropship-drafts/$draftUuid'
    | '/quotes/$quoteId/comments'
    | '/quotes/$quoteId/emails'
    | '/quotes/$quoteId/share'
    | '/quotes/$quoteId/versions'
    | '/shipping-calculator/quote-attempts/$attemptId'
    | '/warehouse/item/$productId'
    | '/customer-comms/chats'
    | '/customer-comms/store-ai'
    | '/projects/dropship-drafts'
    | '/customers/$groupId/comms/$threadId'
    | '/quotes/$quoteId/workflow/$stage'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/callback'
    | '/login'
    | '/_authenticated/ai'
    | '/_authenticated/ai-costs'
    | '/_authenticated/analytics'
    | '/_authenticated/ap-vendors'
    | '/_authenticated/catalog-search'
    | '/_authenticated/catalog-sources'
    | '/_authenticated/communications'
    | '/_authenticated/company'
    | '/_authenticated/contacts'
    | '/_authenticated/customer-comms'
    | '/_authenticated/customers'
    | '/_authenticated/dashboard'
    | '/_authenticated/e2e-testing'
    | '/_authenticated/invoices'
    | '/_authenticated/learn'
    | '/_authenticated/manufacturers'
    | '/_authenticated/order-review'
    | '/_authenticated/orders'
    | '/_authenticated/price-matching'
    | '/_authenticated/products'
    | '/_authenticated/projects'
    | '/_authenticated/purchase-orders'
    | '/_authenticated/quality-tiers'
    | '/_authenticated/quoted-vs-actual'
    | '/_authenticated/quotes'
    | '/_authenticated/receivables'
    | '/_authenticated/shipments'
    | '/_authenticated/shipping-calculator'
    | '/_authenticated/sources'
    | '/_authenticated/specials'
    | '/_authenticated/staff'
    | '/_authenticated/store-readiness'
    | '/_authenticated/suppliers'
    | '/_authenticated/tax-exemptions'
    | '/_authenticated/tax-rates'
    | '/_authenticated/warehouse'
    | '/_authenticated/warranty-claims'
    | '/_authenticated/ai/$agentKey'
    | '/_authenticated/ai/api-keys'
    | '/_authenticated/ap-vendors/$vendorId'
    | '/_authenticated/contacts/$contactId'
    | '/_authenticated/customer-comms/$threadId'
    | '/_authenticated/customer-comms/store-ai'
    | '/_authenticated/customers/$groupId'
    | '/_authenticated/invoices/$invoiceId'
    | '/_authenticated/learn/$lessonKey'
    | '/_authenticated/learn/team'
    | '/_authenticated/manufacturers/$manuId'
    | '/_authenticated/order-review/$findingId'
    | '/_authenticated/orders/$orderId'
    | '/_authenticated/products/$productId'
    | '/_authenticated/projects/$projectId'
    | '/_authenticated/projects/action-items'
    | '/_authenticated/projects/sales-overview'
    | '/_authenticated/projects/timeline'
    | '/_authenticated/projects/waiting-on'
    | '/_authenticated/purchase-orders/$poId'
    | '/_authenticated/quotes/$quoteId'
    | '/_authenticated/quotes/new'
    | '/_authenticated/receivables/$invoiceId'
    | '/_authenticated/shipments/$shipmentId'
    | '/_authenticated/staff/$staffId'
    | '/_authenticated/staff/defaults'
    | '/_authenticated/suppliers/$supplierId'
    | '/_authenticated/tax-exemptions/$formId'
    | '/_authenticated/warehouse/$stockId'
    | '/_authenticated/warehouse/locations'
    | '/_authenticated/ai/'
    | '/_authenticated/contacts/'
    | '/_authenticated/customer-comms/'
    | '/_authenticated/customers/'
    | '/_authenticated/invoices/'
    | '/_authenticated/learn/'
    | '/_authenticated/manufacturers/'
    | '/_authenticated/order-review/'
    | '/_authenticated/orders/'
    | '/_authenticated/products/'
    | '/_authenticated/projects/'
    | '/_authenticated/purchase-orders/'
    | '/_authenticated/quotes/'
    | '/_authenticated/receivables/'
    | '/_authenticated/shipments/'
    | '/_authenticated/shipping-calculator/'
    | '/_authenticated/staff/'
    | '/_authenticated/suppliers/'
    | '/_authenticated/tax-exemptions/'
    | '/_authenticated/warehouse/'
    | '/_authenticated/customer-comms/chats/$conversationId'
    | '/_authenticated/customer-comms/store-ai/$chatId'
    | '/_authenticated/projects/dropship-drafts/$draftUuid'
    | '/_authenticated/quotes/$quoteId/comments'
    | '/_authenticated/quotes/$quoteId/emails'
    | '/_authenticated/quotes/$quoteId/share'
    | '/_authenticated/quotes/$quoteId/versions'
    | '/_authenticated/shipping-calculator/quote-attempts/$attemptId'
    | '/_authenticated/warehouse/item/$productId'
    | '/_authenticated/customer-comms/chats/'
    | '/_authenticated/customer-comms/store-ai/'
    | '/_authenticated/projects/dropship-drafts/'
    | '/_authenticated/customers/$groupId_/comms/$threadId'
    | '/_authenticated/quotes/$quoteId/workflow/$stage'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  CallbackRoute: typeof CallbackRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/warranty-claims': {
      id: '/_authenticated/warranty-claims'
      path: '/warranty-claims'
      fullPath: '/warranty-claims'
      preLoaderRoute: typeof AuthenticatedWarrantyClaimsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/warehouse': {
      id: '/_authenticated/warehouse'
      path: '/warehouse'
      fullPath: '/warehouse'
      preLoaderRoute: typeof AuthenticatedWarehouseRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tax-rates': {
      id: '/_authenticated/tax-rates'
      path: '/tax-rates'
      fullPath: '/tax-rates'
      preLoaderRoute: typeof AuthenticatedTaxRatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tax-exemptions': {
      id: '/_authenticated/tax-exemptions'
      path: '/tax-exemptions'
      fullPath: '/tax-exemptions'
      preLoaderRoute: typeof AuthenticatedTaxExemptionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers': {
      id: '/_authenticated/suppliers'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof AuthenticatedSuppliersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/store-readiness': {
      id: '/_authenticated/store-readiness'
      path: '/store-readiness'
      fullPath: '/store-readiness'
      preLoaderRoute: typeof AuthenticatedStoreReadinessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/staff': {
      id: '/_authenticated/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof AuthenticatedStaffRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/specials': {
      id: '/_authenticated/specials'
      path: '/specials'
      fullPath: '/specials'
      preLoaderRoute: typeof AuthenticatedSpecialsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sources': {
      id: '/_authenticated/sources'
      path: '/sources'
      fullPath: '/sources'
      preLoaderRoute: typeof AuthenticatedSourcesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/shipping-calculator': {
      id: '/_authenticated/shipping-calculator'
      path: '/shipping-calculator'
      fullPath: '/shipping-calculator'
      preLoaderRoute: typeof AuthenticatedShippingCalculatorRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/shipments': {
      id: '/_authenticated/shipments'
      path: '/shipments'
      fullPath: '/shipments'
      preLoaderRoute: typeof AuthenticatedShipmentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/receivables': {
      id: '/_authenticated/receivables'
      path: '/receivables'
      fullPath: '/receivables'
      preLoaderRoute: typeof AuthenticatedReceivablesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/quotes': {
      id: '/_authenticated/quotes'
      path: '/quotes'
      fullPath: '/quotes'
      preLoaderRoute: typeof AuthenticatedQuotesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/quoted-vs-actual': {
      id: '/_authenticated/quoted-vs-actual'
      path: '/quoted-vs-actual'
      fullPath: '/quoted-vs-actual'
      preLoaderRoute: typeof AuthenticatedQuotedVsActualRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/quality-tiers': {
      id: '/_authenticated/quality-tiers'
      path: '/quality-tiers'
      fullPath: '/quality-tiers'
      preLoaderRoute: typeof AuthenticatedQualityTiersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchase-orders': {
      id: '/_authenticated/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/purchase-orders'
      preLoaderRoute: typeof AuthenticatedPurchaseOrdersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects': {
      id: '/_authenticated/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AuthenticatedProjectsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products': {
      id: '/_authenticated/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AuthenticatedProductsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/price-matching': {
      id: '/_authenticated/price-matching'
      path: '/price-matching'
      fullPath: '/price-matching'
      preLoaderRoute: typeof AuthenticatedPriceMatchingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders': {
      id: '/_authenticated/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AuthenticatedOrdersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/order-review': {
      id: '/_authenticated/order-review'
      path: '/order-review'
      fullPath: '/order-review'
      preLoaderRoute: typeof AuthenticatedOrderReviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/manufacturers': {
      id: '/_authenticated/manufacturers'
      path: '/manufacturers'
      fullPath: '/manufacturers'
      preLoaderRoute: typeof AuthenticatedManufacturersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/learn': {
      id: '/_authenticated/learn'
      path: '/learn'
      fullPath: '/learn'
      preLoaderRoute: typeof AuthenticatedLearnRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invoices': {
      id: '/_authenticated/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AuthenticatedInvoicesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/e2e-testing': {
      id: '/_authenticated/e2e-testing'
      path: '/e2e-testing'
      fullPath: '/e2e-testing'
      preLoaderRoute: typeof AuthenticatedE2eTestingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers': {
      id: '/_authenticated/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthenticatedCustomersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customer-comms': {
      id: '/_authenticated/customer-comms'
      path: '/customer-comms'
      fullPath: '/customer-comms'
      preLoaderRoute: typeof AuthenticatedCustomerCommsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contacts': {
      id: '/_authenticated/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AuthenticatedContactsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/company': {
      id: '/_authenticated/company'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof AuthenticatedCompanyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/communications': {
      id: '/_authenticated/communications'
      path: '/communications'
      fullPath: '/communications'
      preLoaderRoute: typeof AuthenticatedCommunicationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/catalog-sources': {
      id: '/_authenticated/catalog-sources'
      path: '/catalog-sources'
      fullPath: '/catalog-sources'
      preLoaderRoute: typeof AuthenticatedCatalogSourcesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/catalog-search': {
      id: '/_authenticated/catalog-search'
      path: '/catalog-search'
      fullPath: '/catalog-search'
      preLoaderRoute: typeof AuthenticatedCatalogSearchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ap-vendors': {
      id: '/_authenticated/ap-vendors'
      path: '/ap-vendors'
      fullPath: '/ap-vendors'
      preLoaderRoute: typeof AuthenticatedApVendorsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analytics': {
      id: '/_authenticated/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthenticatedAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai-costs': {
      id: '/_authenticated/ai-costs'
      path: '/ai-costs'
      fullPath: '/ai-costs'
      preLoaderRoute: typeof AuthenticatedAiCostsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai': {
      id: '/_authenticated/ai'
      path: '/ai'
      fullPath: '/ai'
      preLoaderRoute: typeof AuthenticatedAiRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/warehouse/': {
      id: '/_authenticated/warehouse/'
      path: '/'
      fullPath: '/warehouse/'
      preLoaderRoute: typeof AuthenticatedWarehouseIndexRouteImport
      parentRoute: typeof AuthenticatedWarehouseRoute
    }
    '/_authenticated/tax-exemptions/': {
      id: '/_authenticated/tax-exemptions/'
      path: '/'
      fullPath: '/tax-exemptions/'
      preLoaderRoute: typeof AuthenticatedTaxExemptionsIndexRouteImport
      parentRoute: typeof AuthenticatedTaxExemptionsRoute
    }
    '/_authenticated/suppliers/': {
      id: '/_authenticated/suppliers/'
      path: '/'
      fullPath: '/suppliers/'
      preLoaderRoute: typeof AuthenticatedSuppliersIndexRouteImport
      parentRoute: typeof AuthenticatedSuppliersRoute
    }
    '/_authenticated/staff/': {
      id: '/_authenticated/staff/'
      path: '/'
      fullPath: '/staff/'
      preLoaderRoute: typeof AuthenticatedStaffIndexRouteImport
      parentRoute: typeof AuthenticatedStaffRoute
    }
    '/_authenticated/shipping-calculator/': {
      id: '/_authenticated/shipping-calculator/'
      path: '/'
      fullPath: '/shipping-calculator/'
      preLoaderRoute: typeof AuthenticatedShippingCalculatorIndexRouteImport
      parentRoute: typeof AuthenticatedShippingCalculatorRoute
    }
    '/_authenticated/shipments/': {
      id: '/_authenticated/shipments/'
      path: '/'
      fullPath: '/shipments/'
      preLoaderRoute: typeof AuthenticatedShipmentsIndexRouteImport
      parentRoute: typeof AuthenticatedShipmentsRoute
    }
    '/_authenticated/receivables/': {
      id: '/_authenticated/receivables/'
      path: '/'
      fullPath: '/receivables/'
      preLoaderRoute: typeof AuthenticatedReceivablesIndexRouteImport
      parentRoute: typeof AuthenticatedReceivablesRoute
    }
    '/_authenticated/quotes/': {
      id: '/_authenticated/quotes/'
      path: '/'
      fullPath: '/quotes/'
      preLoaderRoute: typeof AuthenticatedQuotesIndexRouteImport
      parentRoute: typeof AuthenticatedQuotesRoute
    }
    '/_authenticated/purchase-orders/': {
      id: '/_authenticated/purchase-orders/'
      path: '/'
      fullPath: '/purchase-orders/'
      preLoaderRoute: typeof AuthenticatedPurchaseOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedPurchaseOrdersRoute
    }
    '/_authenticated/projects/': {
      id: '/_authenticated/projects/'
      path: '/'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthenticatedProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedProjectsRoute
    }
    '/_authenticated/products/': {
      id: '/_authenticated/products/'
      path: '/'
      fullPath: '/products/'
      preLoaderRoute: typeof AuthenticatedProductsIndexRouteImport
      parentRoute: typeof AuthenticatedProductsRoute
    }
    '/_authenticated/orders/': {
      id: '/_authenticated/orders/'
      path: '/'
      fullPath: '/orders/'
      preLoaderRoute: typeof AuthenticatedOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedOrdersRoute
    }
    '/_authenticated/order-review/': {
      id: '/_authenticated/order-review/'
      path: '/'
      fullPath: '/order-review/'
      preLoaderRoute: typeof AuthenticatedOrderReviewIndexRouteImport
      parentRoute: typeof AuthenticatedOrderReviewRoute
    }
    '/_authenticated/manufacturers/': {
      id: '/_authenticated/manufacturers/'
      path: '/'
      fullPath: '/manufacturers/'
      preLoaderRoute: typeof AuthenticatedManufacturersIndexRouteImport
      parentRoute: typeof AuthenticatedManufacturersRoute
    }
    '/_authenticated/learn/': {
      id: '/_authenticated/learn/'
      path: '/'
      fullPath: '/learn/'
      preLoaderRoute: typeof AuthenticatedLearnIndexRouteImport
      parentRoute: typeof AuthenticatedLearnRoute
    }
    '/_authenticated/invoices/': {
      id: '/_authenticated/invoices/'
      path: '/'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AuthenticatedInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/customers/': {
      id: '/_authenticated/customers/'
      path: '/'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthenticatedCustomersIndexRouteImport
      parentRoute: typeof AuthenticatedCustomersRoute
    }
    '/_authenticated/customer-comms/': {
      id: '/_authenticated/customer-comms/'
      path: '/'
      fullPath: '/customer-comms/'
      preLoaderRoute: typeof AuthenticatedCustomerCommsIndexRouteImport
      parentRoute: typeof AuthenticatedCustomerCommsRoute
    }
    '/_authenticated/contacts/': {
      id: '/_authenticated/contacts/'
      path: '/'
      fullPath: '/contacts/'
      preLoaderRoute: typeof AuthenticatedContactsIndexRouteImport
      parentRoute: typeof AuthenticatedContactsRoute
    }
    '/_authenticated/ai/': {
      id: '/_authenticated/ai/'
      path: '/'
      fullPath: '/ai/'
      preLoaderRoute: typeof AuthenticatedAiIndexRouteImport
      parentRoute: typeof AuthenticatedAiRoute
    }
    '/_authenticated/warehouse/locations': {
      id: '/_authenticated/warehouse/locations'
      path: '/locations'
      fullPath: '/warehouse/locations'
      preLoaderRoute: typeof AuthenticatedWarehouseLocationsRouteImport
      parentRoute: typeof AuthenticatedWarehouseRoute
    }
    '/_authenticated/warehouse/$stockId': {
      id: '/_authenticated/warehouse/$stockId'
      path: '/$stockId'
      fullPath: '/warehouse/$stockId'
      preLoaderRoute: typeof AuthenticatedWarehouseStockIdRouteImport
      parentRoute: typeof AuthenticatedWarehouseRoute
    }
    '/_authenticated/tax-exemptions/$formId': {
      id: '/_authenticated/tax-exemptions/$formId'
      path: '/$formId'
      fullPath: '/tax-exemptions/$formId'
      preLoaderRoute: typeof AuthenticatedTaxExemptionsFormIdRouteImport
      parentRoute: typeof AuthenticatedTaxExemptionsRoute
    }
    '/_authenticated/suppliers/$supplierId': {
      id: '/_authenticated/suppliers/$supplierId'
      path: '/$supplierId'
      fullPath: '/suppliers/$supplierId'
      preLoaderRoute: typeof AuthenticatedSuppliersSupplierIdRouteImport
      parentRoute: typeof AuthenticatedSuppliersRoute
    }
    '/_authenticated/staff/defaults': {
      id: '/_authenticated/staff/defaults'
      path: '/defaults'
      fullPath: '/staff/defaults'
      preLoaderRoute: typeof AuthenticatedStaffDefaultsRouteImport
      parentRoute: typeof AuthenticatedStaffRoute
    }
    '/_authenticated/staff/$staffId': {
      id: '/_authenticated/staff/$staffId'
      path: '/$staffId'
      fullPath: '/staff/$staffId'
      preLoaderRoute: typeof AuthenticatedStaffStaffIdRouteImport
      parentRoute: typeof AuthenticatedStaffRoute
    }
    '/_authenticated/shipments/$shipmentId': {
      id: '/_authenticated/shipments/$shipmentId'
      path: '/$shipmentId'
      fullPath: '/shipments/$shipmentId'
      preLoaderRoute: typeof AuthenticatedShipmentsShipmentIdRouteImport
      parentRoute: typeof AuthenticatedShipmentsRoute
    }
    '/_authenticated/receivables/$invoiceId': {
      id: '/_authenticated/receivables/$invoiceId'
      path: '/$invoiceId'
      fullPath: '/receivables/$invoiceId'
      preLoaderRoute: typeof AuthenticatedReceivablesInvoiceIdRouteImport
      parentRoute: typeof AuthenticatedReceivablesRoute
    }
    '/_authenticated/quotes/new': {
      id: '/_authenticated/quotes/new'
      path: '/new'
      fullPath: '/quotes/new'
      preLoaderRoute: typeof AuthenticatedQuotesNewRouteImport
      parentRoute: typeof AuthenticatedQuotesRoute
    }
    '/_authenticated/quotes/$quoteId': {
      id: '/_authenticated/quotes/$quoteId'
      path: '/$quoteId'
      fullPath: '/quotes/$quoteId'
      preLoaderRoute: typeof AuthenticatedQuotesQuoteIdRouteImport
      parentRoute: typeof AuthenticatedQuotesRoute
    }
    '/_authenticated/purchase-orders/$poId': {
      id: '/_authenticated/purchase-orders/$poId'
      path: '/$poId'
      fullPath: '/purchase-orders/$poId'
      preLoaderRoute: typeof AuthenticatedPurchaseOrdersPoIdRouteImport
      parentRoute: typeof AuthenticatedPurchaseOrdersRoute
    }
    '/_authenticated/projects/waiting-on': {
      id: '/_authenticated/projects/waiting-on'
      path: '/waiting-on'
      fullPath: '/projects/waiting-on'
      preLoaderRoute: typeof AuthenticatedProjectsWaitingOnRouteImport
      parentRoute: typeof AuthenticatedProjectsRoute
    }
    '/_authenticated/projects/timeline': {
      id: '/_authenticated/projects/timeline'
      path: '/timeline'
      fullPath: '/projects/timeline'
      preLoaderRoute: typeof AuthenticatedProjectsTimelineRouteImport
      parentRoute: typeof AuthenticatedProjectsRoute
    }
    '/_authenticated/projects/sales-overview': {
      id: '/_authenticated/projects/sales-overview'
      path: '/sales-overview'
      fullPath: '/projects/sales-overview'
      preLoaderRoute: typeof AuthenticatedProjectsSalesOverviewRouteImport
      parentRoute: typeof AuthenticatedProjectsRoute
    }
    '/_authenticated/projects/action-items': {
      id: '/_authenticated/projects/action-items'
      path: '/action-items'
      fullPath: '/projects/action-items'
      preLoaderRoute: typeof AuthenticatedProjectsActionItemsRouteImport
      parentRoute: typeof AuthenticatedProjectsRoute
    }
    '/_authenticated/projects/$projectId': {
      id: '/_authenticated/projects/$projectId'
      path: '/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdRouteImport
      parentRoute: typeof AuthenticatedProjectsRoute
    }
    '/_authenticated/products/$productId': {
      id: '/_authenticated/products/$productId'
      path: '/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof AuthenticatedProductsProductIdRouteImport
      parentRoute: typeof AuthenticatedProductsRoute
    }
    '/_authenticated/orders/$orderId': {
      id: '/_authenticated/orders/$orderId'
      path: '/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AuthenticatedOrdersOrderIdRouteImport
      parentRoute: typeof AuthenticatedOrdersRoute
    }
    '/_authenticated/order-review/$findingId': {
      id: '/_authenticated/order-review/$findingId'
      path: '/$findingId'
      fullPath: '/order-review/$findingId'
      preLoaderRoute: typeof AuthenticatedOrderReviewFindingIdRouteImport
      parentRoute: typeof AuthenticatedOrderReviewRoute
    }
    '/_authenticated/manufacturers/$manuId': {
      id: '/_authenticated/manufacturers/$manuId'
      path: '/$manuId'
      fullPath: '/manufacturers/$manuId'
      preLoaderRoute: typeof AuthenticatedManufacturersManuIdRouteImport
      parentRoute: typeof AuthenticatedManufacturersRoute
    }
    '/_authenticated/learn/team': {
      id: '/_authenticated/learn/team'
      path: '/team'
      fullPath: '/learn/team'
      preLoaderRoute: typeof AuthenticatedLearnTeamRouteImport
      parentRoute: typeof AuthenticatedLearnRoute
    }
    '/_authenticated/learn/$lessonKey': {
      id: '/_authenticated/learn/$lessonKey'
      path: '/$lessonKey'
      fullPath: '/learn/$lessonKey'
      preLoaderRoute: typeof AuthenticatedLearnLessonKeyRouteImport
      parentRoute: typeof AuthenticatedLearnRoute
    }
    '/_authenticated/invoices/$invoiceId': {
      id: '/_authenticated/invoices/$invoiceId'
      path: '/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof AuthenticatedInvoicesInvoiceIdRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/customers/$groupId': {
      id: '/_authenticated/customers/$groupId'
      path: '/$groupId'
      fullPath: '/customers/$groupId'
      preLoaderRoute: typeof AuthenticatedCustomersGroupIdRouteImport
      parentRoute: typeof AuthenticatedCustomersRoute
    }
    '/_authenticated/customer-comms/store-ai': {
      id: '/_authenticated/customer-comms/store-ai'
      path: '/store-ai'
      fullPath: '/customer-comms/store-ai'
      preLoaderRoute: typeof AuthenticatedCustomerCommsStoreAiRouteImport
      parentRoute: typeof AuthenticatedCustomerCommsRoute
    }
    '/_authenticated/customer-comms/$threadId': {
      id: '/_authenticated/customer-comms/$threadId'
      path: '/$threadId'
      fullPath: '/customer-comms/$threadId'
      preLoaderRoute: typeof AuthenticatedCustomerCommsThreadIdRouteImport
      parentRoute: typeof AuthenticatedCustomerCommsRoute
    }
    '/_authenticated/contacts/$contactId': {
      id: '/_authenticated/contacts/$contactId'
      path: '/$contactId'
      fullPath: '/contacts/$contactId'
      preLoaderRoute: typeof AuthenticatedContactsContactIdRouteImport
      parentRoute: typeof AuthenticatedContactsRoute
    }
    '/_authenticated/ap-vendors/$vendorId': {
      id: '/_authenticated/ap-vendors/$vendorId'
      path: '/$vendorId'
      fullPath: '/ap-vendors/$vendorId'
      preLoaderRoute: typeof AuthenticatedApVendorsVendorIdRouteImport
      parentRoute: typeof AuthenticatedApVendorsRoute
    }
    '/_authenticated/ai/api-keys': {
      id: '/_authenticated/ai/api-keys'
      path: '/api-keys'
      fullPath: '/ai/api-keys'
      preLoaderRoute: typeof AuthenticatedAiApiKeysRouteImport
      parentRoute: typeof AuthenticatedAiRoute
    }
    '/_authenticated/ai/$agentKey': {
      id: '/_authenticated/ai/$agentKey'
      path: '/$agentKey'
      fullPath: '/ai/$agentKey'
      preLoaderRoute: typeof AuthenticatedAiAgentKeyRouteImport
      parentRoute: typeof AuthenticatedAiRoute
    }
    '/_authenticated/projects/dropship-drafts/': {
      id: '/_authenticated/projects/dropship-drafts/'
      path: '/dropship-drafts'
      fullPath: '/projects/dropship-drafts/'
      preLoaderRoute: typeof AuthenticatedProjectsDropshipDraftsIndexRouteImport
      parentRoute: typeof AuthenticatedProjectsRoute
    }
    '/_authenticated/customer-comms/store-ai/': {
      id: '/_authenticated/customer-comms/store-ai/'
      path: '/'
      fullPath: '/customer-comms/store-ai/'
      preLoaderRoute: typeof AuthenticatedCustomerCommsStoreAiIndexRouteImport
      parentRoute: typeof AuthenticatedCustomerCommsStoreAiRoute
    }
    '/_authenticated/customer-comms/chats/': {
      id: '/_authenticated/customer-comms/chats/'
      path: '/chats'
      fullPath: '/customer-comms/chats/'
      preLoaderRoute: typeof AuthenticatedCustomerCommsChatsIndexRouteImport
      parentRoute: typeof AuthenticatedCustomerCommsRoute
    }
    '/_authenticated/warehouse/item/$productId': {
      id: '/_authenticated/warehouse/item/$productId'
      path: '/item/$productId'
      fullPath: '/warehouse/item/$productId'
      preLoaderRoute: typeof AuthenticatedWarehouseItemProductIdRouteImport
      parentRoute: typeof AuthenticatedWarehouseRoute
    }
    '/_authenticated/shipping-calculator/quote-attempts/$attemptId': {
      id: '/_authenticated/shipping-calculator/quote-attempts/$attemptId'
      path: '/quote-attempts/$attemptId'
      fullPath: '/shipping-calculator/quote-attempts/$attemptId'
      preLoaderRoute: typeof AuthenticatedShippingCalculatorQuoteAttemptsAttemptIdRouteImport
      parentRoute: typeof AuthenticatedShippingCalculatorRoute
    }
    '/_authenticated/quotes/$quoteId/versions': {
      id: '/_authenticated/quotes/$quoteId/versions'
      path: '/versions'
      fullPath: '/quotes/$quoteId/versions'
      preLoaderRoute: typeof AuthenticatedQuotesQuoteIdVersionsRouteImport
      parentRoute: typeof AuthenticatedQuotesQuoteIdRoute
    }
    '/_authenticated/quotes/$quoteId/share': {
      id: '/_authenticated/quotes/$quoteId/share'
      path: '/share'
      fullPath: '/quotes/$quoteId/share'
      preLoaderRoute: typeof AuthenticatedQuotesQuoteIdShareRouteImport
      parentRoute: typeof AuthenticatedQuotesQuoteIdRoute
    }
    '/_authenticated/quotes/$quoteId/emails': {
      id: '/_authenticated/quotes/$quoteId/emails'
      path: '/emails'
      fullPath: '/quotes/$quoteId/emails'
      preLoaderRoute: typeof AuthenticatedQuotesQuoteIdEmailsRouteImport
      parentRoute: typeof AuthenticatedQuotesQuoteIdRoute
    }
    '/_authenticated/quotes/$quoteId/comments': {
      id: '/_authenticated/quotes/$quoteId/comments'
      path: '/comments'
      fullPath: '/quotes/$quoteId/comments'
      preLoaderRoute: typeof AuthenticatedQuotesQuoteIdCommentsRouteImport
      parentRoute: typeof AuthenticatedQuotesQuoteIdRoute
    }
    '/_authenticated/projects/dropship-drafts/$draftUuid': {
      id: '/_authenticated/projects/dropship-drafts/$draftUuid'
      path: '/dropship-drafts/$draftUuid'
      fullPath: '/projects/dropship-drafts/$draftUuid'
      preLoaderRoute: typeof AuthenticatedProjectsDropshipDraftsDraftUuidRouteImport
      parentRoute: typeof AuthenticatedProjectsRoute
    }
    '/_authenticated/customer-comms/store-ai/$chatId': {
      id: '/_authenticated/customer-comms/store-ai/$chatId'
      path: '/$chatId'
      fullPath: '/customer-comms/store-ai/$chatId'
      preLoaderRoute: typeof AuthenticatedCustomerCommsStoreAiChatIdRouteImport
      parentRoute: typeof AuthenticatedCustomerCommsStoreAiRoute
    }
    '/_authenticated/customer-comms/chats/$conversationId': {
      id: '/_authenticated/customer-comms/chats/$conversationId'
      path: '/chats/$conversationId'
      fullPath: '/customer-comms/chats/$conversationId'
      preLoaderRoute: typeof AuthenticatedCustomerCommsChatsConversationIdRouteImport
      parentRoute: typeof AuthenticatedCustomerCommsRoute
    }
    '/_authenticated/quotes/$quoteId/workflow/$stage': {
      id: '/_authenticated/quotes/$quoteId/workflow/$stage'
      path: '/workflow/$stage'
      fullPath: '/quotes/$quoteId/workflow/$stage'
      preLoaderRoute: typeof AuthenticatedQuotesQuoteIdWorkflowStageRouteImport
      parentRoute: typeof AuthenticatedQuotesQuoteIdRoute
    }
    '/_authenticated/customers/$groupId_/comms/$threadId': {
      id: '/_authenticated/customers/$groupId_/comms/$threadId'
      path: '/$groupId/comms/$threadId'
      fullPath: '/customers/$groupId/comms/$threadId'
      preLoaderRoute: typeof AuthenticatedCustomersGroupIdCommsThreadIdRouteImport
      parentRoute: typeof AuthenticatedCustomersRoute
    }
  }
}

interface AuthenticatedAiRouteChildren {
  AuthenticatedAiAgentKeyRoute: typeof AuthenticatedAiAgentKeyRoute
  AuthenticatedAiApiKeysRoute: typeof AuthenticatedAiApiKeysRoute
  AuthenticatedAiIndexRoute: typeof AuthenticatedAiIndexRoute
}

const AuthenticatedAiRouteChildren: AuthenticatedAiRouteChildren = {
  AuthenticatedAiAgentKeyRoute: AuthenticatedAiAgentKeyRoute,
  AuthenticatedAiApiKeysRoute: AuthenticatedAiApiKeysRoute,
  AuthenticatedAiIndexRoute: AuthenticatedAiIndexRoute,
}

const AuthenticatedAiRouteWithChildren = AuthenticatedAiRoute._addFileChildren(
  AuthenticatedAiRouteChildren,
)

interface AuthenticatedApVendorsRouteChildren {
  AuthenticatedApVendorsVendorIdRoute: typeof AuthenticatedApVendorsVendorIdRoute
}

const AuthenticatedApVendorsRouteChildren: AuthenticatedApVendorsRouteChildren =
  {
    AuthenticatedApVendorsVendorIdRoute: AuthenticatedApVendorsVendorIdRoute,
  }

const AuthenticatedApVendorsRouteWithChildren =
  AuthenticatedApVendorsRoute._addFileChildren(
    AuthenticatedApVendorsRouteChildren,
  )

interface AuthenticatedContactsRouteChildren {
  AuthenticatedContactsContactIdRoute: typeof AuthenticatedContactsContactIdRoute
  AuthenticatedContactsIndexRoute: typeof AuthenticatedContactsIndexRoute
}

const AuthenticatedContactsRouteChildren: AuthenticatedContactsRouteChildren = {
  AuthenticatedContactsContactIdRoute: AuthenticatedContactsContactIdRoute,
  AuthenticatedContactsIndexRoute: AuthenticatedContactsIndexRoute,
}

const AuthenticatedContactsRouteWithChildren =
  AuthenticatedContactsRoute._addFileChildren(
    AuthenticatedContactsRouteChildren,
  )

interface AuthenticatedCustomerCommsStoreAiRouteChildren {
  AuthenticatedCustomerCommsStoreAiChatIdRoute: typeof AuthenticatedCustomerCommsStoreAiChatIdRoute
  AuthenticatedCustomerCommsStoreAiIndexRoute: typeof AuthenticatedCustomerCommsStoreAiIndexRoute
}

const AuthenticatedCustomerCommsStoreAiRouteChildren: AuthenticatedCustomerCommsStoreAiRouteChildren =
  {
    AuthenticatedCustomerCommsStoreAiChatIdRoute:
      AuthenticatedCustomerCommsStoreAiChatIdRoute,
    AuthenticatedCustomerCommsStoreAiIndexRoute:
      AuthenticatedCustomerCommsStoreAiIndexRoute,
  }

const AuthenticatedCustomerCommsStoreAiRouteWithChildren =
  AuthenticatedCustomerCommsStoreAiRoute._addFileChildren(
    AuthenticatedCustomerCommsStoreAiRouteChildren,
  )

interface AuthenticatedCustomerCommsRouteChildren {
  AuthenticatedCustomerCommsThreadIdRoute: typeof AuthenticatedCustomerCommsThreadIdRoute
  AuthenticatedCustomerCommsStoreAiRoute: typeof AuthenticatedCustomerCommsStoreAiRouteWithChildren
  AuthenticatedCustomerCommsIndexRoute: typeof AuthenticatedCustomerCommsIndexRoute
  AuthenticatedCustomerCommsChatsConversationIdRoute: typeof AuthenticatedCustomerCommsChatsConversationIdRoute
  AuthenticatedCustomerCommsChatsIndexRoute: typeof AuthenticatedCustomerCommsChatsIndexRoute
}

const AuthenticatedCustomerCommsRouteChildren: AuthenticatedCustomerCommsRouteChildren =
  {
    AuthenticatedCustomerCommsThreadIdRoute:
      AuthenticatedCustomerCommsThreadIdRoute,
    AuthenticatedCustomerCommsStoreAiRoute:
      AuthenticatedCustomerCommsStoreAiRouteWithChildren,
    AuthenticatedCustomerCommsIndexRoute: AuthenticatedCustomerCommsIndexRoute,
    AuthenticatedCustomerCommsChatsConversationIdRoute:
      AuthenticatedCustomerCommsChatsConversationIdRoute,
    AuthenticatedCustomerCommsChatsIndexRoute:
      AuthenticatedCustomerCommsChatsIndexRoute,
  }

const AuthenticatedCustomerCommsRouteWithChildren =
  AuthenticatedCustomerCommsRoute._addFileChildren(
    AuthenticatedCustomerCommsRouteChildren,
  )

interface AuthenticatedCustomersRouteChildren {
  AuthenticatedCustomersGroupIdRoute: typeof AuthenticatedCustomersGroupIdRoute
  AuthenticatedCustomersIndexRoute: typeof AuthenticatedCustomersIndexRoute
  AuthenticatedCustomersGroupIdCommsThreadIdRoute: typeof AuthenticatedCustomersGroupIdCommsThreadIdRoute
}

const AuthenticatedCustomersRouteChildren: AuthenticatedCustomersRouteChildren =
  {
    AuthenticatedCustomersGroupIdRoute: AuthenticatedCustomersGroupIdRoute,
    AuthenticatedCustomersIndexRoute: AuthenticatedCustomersIndexRoute,
    AuthenticatedCustomersGroupIdCommsThreadIdRoute:
      AuthenticatedCustomersGroupIdCommsThreadIdRoute,
  }

const AuthenticatedCustomersRouteWithChildren =
  AuthenticatedCustomersRoute._addFileChildren(
    AuthenticatedCustomersRouteChildren,
  )

interface AuthenticatedInvoicesRouteChildren {
  AuthenticatedInvoicesInvoiceIdRoute: typeof AuthenticatedInvoicesInvoiceIdRoute
  AuthenticatedInvoicesIndexRoute: typeof AuthenticatedInvoicesIndexRoute
}

const AuthenticatedInvoicesRouteChildren: AuthenticatedInvoicesRouteChildren = {
  AuthenticatedInvoicesInvoiceIdRoute: AuthenticatedInvoicesInvoiceIdRoute,
  AuthenticatedInvoicesIndexRoute: AuthenticatedInvoicesIndexRoute,
}

const AuthenticatedInvoicesRouteWithChildren =
  AuthenticatedInvoicesRoute._addFileChildren(
    AuthenticatedInvoicesRouteChildren,
  )

interface AuthenticatedLearnRouteChildren {
  AuthenticatedLearnLessonKeyRoute: typeof AuthenticatedLearnLessonKeyRoute
  AuthenticatedLearnTeamRoute: typeof AuthenticatedLearnTeamRoute
  AuthenticatedLearnIndexRoute: typeof AuthenticatedLearnIndexRoute
}

const AuthenticatedLearnRouteChildren: AuthenticatedLearnRouteChildren = {
  AuthenticatedLearnLessonKeyRoute: AuthenticatedLearnLessonKeyRoute,
  AuthenticatedLearnTeamRoute: AuthenticatedLearnTeamRoute,
  AuthenticatedLearnIndexRoute: AuthenticatedLearnIndexRoute,
}

const AuthenticatedLearnRouteWithChildren =
  AuthenticatedLearnRoute._addFileChildren(AuthenticatedLearnRouteChildren)

interface AuthenticatedManufacturersRouteChildren {
  AuthenticatedManufacturersManuIdRoute: typeof AuthenticatedManufacturersManuIdRoute
  AuthenticatedManufacturersIndexRoute: typeof AuthenticatedManufacturersIndexRoute
}

const AuthenticatedManufacturersRouteChildren: AuthenticatedManufacturersRouteChildren =
  {
    AuthenticatedManufacturersManuIdRoute:
      AuthenticatedManufacturersManuIdRoute,
    AuthenticatedManufacturersIndexRoute: AuthenticatedManufacturersIndexRoute,
  }

const AuthenticatedManufacturersRouteWithChildren =
  AuthenticatedManufacturersRoute._addFileChildren(
    AuthenticatedManufacturersRouteChildren,
  )

interface AuthenticatedOrderReviewRouteChildren {
  AuthenticatedOrderReviewFindingIdRoute: typeof AuthenticatedOrderReviewFindingIdRoute
  AuthenticatedOrderReviewIndexRoute: typeof AuthenticatedOrderReviewIndexRoute
}

const AuthenticatedOrderReviewRouteChildren: AuthenticatedOrderReviewRouteChildren =
  {
    AuthenticatedOrderReviewFindingIdRoute:
      AuthenticatedOrderReviewFindingIdRoute,
    AuthenticatedOrderReviewIndexRoute: AuthenticatedOrderReviewIndexRoute,
  }

const AuthenticatedOrderReviewRouteWithChildren =
  AuthenticatedOrderReviewRoute._addFileChildren(
    AuthenticatedOrderReviewRouteChildren,
  )

interface AuthenticatedOrdersRouteChildren {
  AuthenticatedOrdersOrderIdRoute: typeof AuthenticatedOrdersOrderIdRoute
  AuthenticatedOrdersIndexRoute: typeof AuthenticatedOrdersIndexRoute
}

const AuthenticatedOrdersRouteChildren: AuthenticatedOrdersRouteChildren = {
  AuthenticatedOrdersOrderIdRoute: AuthenticatedOrdersOrderIdRoute,
  AuthenticatedOrdersIndexRoute: AuthenticatedOrdersIndexRoute,
}

const AuthenticatedOrdersRouteWithChildren =
  AuthenticatedOrdersRoute._addFileChildren(AuthenticatedOrdersRouteChildren)

interface AuthenticatedProductsRouteChildren {
  AuthenticatedProductsProductIdRoute: typeof AuthenticatedProductsProductIdRoute
  AuthenticatedProductsIndexRoute: typeof AuthenticatedProductsIndexRoute
}

const AuthenticatedProductsRouteChildren: AuthenticatedProductsRouteChildren = {
  AuthenticatedProductsProductIdRoute: AuthenticatedProductsProductIdRoute,
  AuthenticatedProductsIndexRoute: AuthenticatedProductsIndexRoute,
}

const AuthenticatedProductsRouteWithChildren =
  AuthenticatedProductsRoute._addFileChildren(
    AuthenticatedProductsRouteChildren,
  )

interface AuthenticatedProjectsRouteChildren {
  AuthenticatedProjectsProjectIdRoute: typeof AuthenticatedProjectsProjectIdRoute
  AuthenticatedProjectsActionItemsRoute: typeof AuthenticatedProjectsActionItemsRoute
  AuthenticatedProjectsSalesOverviewRoute: typeof AuthenticatedProjectsSalesOverviewRoute
  AuthenticatedProjectsTimelineRoute: typeof AuthenticatedProjectsTimelineRoute
  AuthenticatedProjectsWaitingOnRoute: typeof AuthenticatedProjectsWaitingOnRoute
  AuthenticatedProjectsIndexRoute: typeof AuthenticatedProjectsIndexRoute
  AuthenticatedProjectsDropshipDraftsDraftUuidRoute: typeof AuthenticatedProjectsDropshipDraftsDraftUuidRoute
  AuthenticatedProjectsDropshipDraftsIndexRoute: typeof AuthenticatedProjectsDropshipDraftsIndexRoute
}

const AuthenticatedProjectsRouteChildren: AuthenticatedProjectsRouteChildren = {
  AuthenticatedProjectsProjectIdRoute: AuthenticatedProjectsProjectIdRoute,
  AuthenticatedProjectsActionItemsRoute: AuthenticatedProjectsActionItemsRoute,
  AuthenticatedProjectsSalesOverviewRoute:
    AuthenticatedProjectsSalesOverviewRoute,
  AuthenticatedProjectsTimelineRoute: AuthenticatedProjectsTimelineRoute,
  AuthenticatedProjectsWaitingOnRoute: AuthenticatedProjectsWaitingOnRoute,
  AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute,
  AuthenticatedProjectsDropshipDraftsDraftUuidRoute:
    AuthenticatedProjectsDropshipDraftsDraftUuidRoute,
  AuthenticatedProjectsDropshipDraftsIndexRoute:
    AuthenticatedProjectsDropshipDraftsIndexRoute,
}

const AuthenticatedProjectsRouteWithChildren =
  AuthenticatedProjectsRoute._addFileChildren(
    AuthenticatedProjectsRouteChildren,
  )

interface AuthenticatedPurchaseOrdersRouteChildren {
  AuthenticatedPurchaseOrdersPoIdRoute: typeof AuthenticatedPurchaseOrdersPoIdRoute
  AuthenticatedPurchaseOrdersIndexRoute: typeof AuthenticatedPurchaseOrdersIndexRoute
}

const AuthenticatedPurchaseOrdersRouteChildren: AuthenticatedPurchaseOrdersRouteChildren =
  {
    AuthenticatedPurchaseOrdersPoIdRoute: AuthenticatedPurchaseOrdersPoIdRoute,
    AuthenticatedPurchaseOrdersIndexRoute:
      AuthenticatedPurchaseOrdersIndexRoute,
  }

const AuthenticatedPurchaseOrdersRouteWithChildren =
  AuthenticatedPurchaseOrdersRoute._addFileChildren(
    AuthenticatedPurchaseOrdersRouteChildren,
  )

interface AuthenticatedQuotesQuoteIdRouteChildren {
  AuthenticatedQuotesQuoteIdCommentsRoute: typeof AuthenticatedQuotesQuoteIdCommentsRoute
  AuthenticatedQuotesQuoteIdEmailsRoute: typeof AuthenticatedQuotesQuoteIdEmailsRoute
  AuthenticatedQuotesQuoteIdShareRoute: typeof AuthenticatedQuotesQuoteIdShareRoute
  AuthenticatedQuotesQuoteIdVersionsRoute: typeof AuthenticatedQuotesQuoteIdVersionsRoute
  AuthenticatedQuotesQuoteIdWorkflowStageRoute: typeof AuthenticatedQuotesQuoteIdWorkflowStageRoute
}

const AuthenticatedQuotesQuoteIdRouteChildren: AuthenticatedQuotesQuoteIdRouteChildren =
  {
    AuthenticatedQuotesQuoteIdCommentsRoute:
      AuthenticatedQuotesQuoteIdCommentsRoute,
    AuthenticatedQuotesQuoteIdEmailsRoute:
      AuthenticatedQuotesQuoteIdEmailsRoute,
    AuthenticatedQuotesQuoteIdShareRoute: AuthenticatedQuotesQuoteIdShareRoute,
    AuthenticatedQuotesQuoteIdVersionsRoute:
      AuthenticatedQuotesQuoteIdVersionsRoute,
    AuthenticatedQuotesQuoteIdWorkflowStageRoute:
      AuthenticatedQuotesQuoteIdWorkflowStageRoute,
  }

const AuthenticatedQuotesQuoteIdRouteWithChildren =
  AuthenticatedQuotesQuoteIdRoute._addFileChildren(
    AuthenticatedQuotesQuoteIdRouteChildren,
  )

interface AuthenticatedQuotesRouteChildren {
  AuthenticatedQuotesQuoteIdRoute: typeof AuthenticatedQuotesQuoteIdRouteWithChildren
  AuthenticatedQuotesNewRoute: typeof AuthenticatedQuotesNewRoute
  AuthenticatedQuotesIndexRoute: typeof AuthenticatedQuotesIndexRoute
}

const AuthenticatedQuotesRouteChildren: AuthenticatedQuotesRouteChildren = {
  AuthenticatedQuotesQuoteIdRoute: AuthenticatedQuotesQuoteIdRouteWithChildren,
  AuthenticatedQuotesNewRoute: AuthenticatedQuotesNewRoute,
  AuthenticatedQuotesIndexRoute: AuthenticatedQuotesIndexRoute,
}

const AuthenticatedQuotesRouteWithChildren =
  AuthenticatedQuotesRoute._addFileChildren(AuthenticatedQuotesRouteChildren)

interface AuthenticatedReceivablesRouteChildren {
  AuthenticatedReceivablesInvoiceIdRoute: typeof AuthenticatedReceivablesInvoiceIdRoute
  AuthenticatedReceivablesIndexRoute: typeof AuthenticatedReceivablesIndexRoute
}

const AuthenticatedReceivablesRouteChildren: AuthenticatedReceivablesRouteChildren =
  {
    AuthenticatedReceivablesInvoiceIdRoute:
      AuthenticatedReceivablesInvoiceIdRoute,
    AuthenticatedReceivablesIndexRoute: AuthenticatedReceivablesIndexRoute,
  }

const AuthenticatedReceivablesRouteWithChildren =
  AuthenticatedReceivablesRoute._addFileChildren(
    AuthenticatedReceivablesRouteChildren,
  )

interface AuthenticatedShipmentsRouteChildren {
  AuthenticatedShipmentsShipmentIdRoute: typeof AuthenticatedShipmentsShipmentIdRoute
  AuthenticatedShipmentsIndexRoute: typeof AuthenticatedShipmentsIndexRoute
}

const AuthenticatedShipmentsRouteChildren: AuthenticatedShipmentsRouteChildren =
  {
    AuthenticatedShipmentsShipmentIdRoute:
      AuthenticatedShipmentsShipmentIdRoute,
    AuthenticatedShipmentsIndexRoute: AuthenticatedShipmentsIndexRoute,
  }

const AuthenticatedShipmentsRouteWithChildren =
  AuthenticatedShipmentsRoute._addFileChildren(
    AuthenticatedShipmentsRouteChildren,
  )

interface AuthenticatedShippingCalculatorRouteChildren {
  AuthenticatedShippingCalculatorIndexRoute: typeof AuthenticatedShippingCalculatorIndexRoute
  AuthenticatedShippingCalculatorQuoteAttemptsAttemptIdRoute: typeof AuthenticatedShippingCalculatorQuoteAttemptsAttemptIdRoute
}

const AuthenticatedShippingCalculatorRouteChildren: AuthenticatedShippingCalculatorRouteChildren =
  {
    AuthenticatedShippingCalculatorIndexRoute:
      AuthenticatedShippingCalculatorIndexRoute,
    AuthenticatedShippingCalculatorQuoteAttemptsAttemptIdRoute:
      AuthenticatedShippingCalculatorQuoteAttemptsAttemptIdRoute,
  }

const AuthenticatedShippingCalculatorRouteWithChildren =
  AuthenticatedShippingCalculatorRoute._addFileChildren(
    AuthenticatedShippingCalculatorRouteChildren,
  )

interface AuthenticatedStaffRouteChildren {
  AuthenticatedStaffStaffIdRoute: typeof AuthenticatedStaffStaffIdRoute
  AuthenticatedStaffDefaultsRoute: typeof AuthenticatedStaffDefaultsRoute
  AuthenticatedStaffIndexRoute: typeof AuthenticatedStaffIndexRoute
}

const AuthenticatedStaffRouteChildren: AuthenticatedStaffRouteChildren = {
  AuthenticatedStaffStaffIdRoute: AuthenticatedStaffStaffIdRoute,
  AuthenticatedStaffDefaultsRoute: AuthenticatedStaffDefaultsRoute,
  AuthenticatedStaffIndexRoute: AuthenticatedStaffIndexRoute,
}

const AuthenticatedStaffRouteWithChildren =
  AuthenticatedStaffRoute._addFileChildren(AuthenticatedStaffRouteChildren)

interface AuthenticatedSuppliersRouteChildren {
  AuthenticatedSuppliersSupplierIdRoute: typeof AuthenticatedSuppliersSupplierIdRoute
  AuthenticatedSuppliersIndexRoute: typeof AuthenticatedSuppliersIndexRoute
}

const AuthenticatedSuppliersRouteChildren: AuthenticatedSuppliersRouteChildren =
  {
    AuthenticatedSuppliersSupplierIdRoute:
      AuthenticatedSuppliersSupplierIdRoute,
    AuthenticatedSuppliersIndexRoute: AuthenticatedSuppliersIndexRoute,
  }

const AuthenticatedSuppliersRouteWithChildren =
  AuthenticatedSuppliersRoute._addFileChildren(
    AuthenticatedSuppliersRouteChildren,
  )

interface AuthenticatedTaxExemptionsRouteChildren {
  AuthenticatedTaxExemptionsFormIdRoute: typeof AuthenticatedTaxExemptionsFormIdRoute
  AuthenticatedTaxExemptionsIndexRoute: typeof AuthenticatedTaxExemptionsIndexRoute
}

const AuthenticatedTaxExemptionsRouteChildren: AuthenticatedTaxExemptionsRouteChildren =
  {
    AuthenticatedTaxExemptionsFormIdRoute:
      AuthenticatedTaxExemptionsFormIdRoute,
    AuthenticatedTaxExemptionsIndexRoute: AuthenticatedTaxExemptionsIndexRoute,
  }

const AuthenticatedTaxExemptionsRouteWithChildren =
  AuthenticatedTaxExemptionsRoute._addFileChildren(
    AuthenticatedTaxExemptionsRouteChildren,
  )

interface AuthenticatedWarehouseRouteChildren {
  AuthenticatedWarehouseStockIdRoute: typeof AuthenticatedWarehouseStockIdRoute
  AuthenticatedWarehouseLocationsRoute: typeof AuthenticatedWarehouseLocationsRoute
  AuthenticatedWarehouseIndexRoute: typeof AuthenticatedWarehouseIndexRoute
  AuthenticatedWarehouseItemProductIdRoute: typeof AuthenticatedWarehouseItemProductIdRoute
}

const AuthenticatedWarehouseRouteChildren: AuthenticatedWarehouseRouteChildren =
  {
    AuthenticatedWarehouseStockIdRoute: AuthenticatedWarehouseStockIdRoute,
    AuthenticatedWarehouseLocationsRoute: AuthenticatedWarehouseLocationsRoute,
    AuthenticatedWarehouseIndexRoute: AuthenticatedWarehouseIndexRoute,
    AuthenticatedWarehouseItemProductIdRoute:
      AuthenticatedWarehouseItemProductIdRoute,
  }

const AuthenticatedWarehouseRouteWithChildren =
  AuthenticatedWarehouseRoute._addFileChildren(
    AuthenticatedWarehouseRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAiRoute: typeof AuthenticatedAiRouteWithChildren
  AuthenticatedAiCostsRoute: typeof AuthenticatedAiCostsRoute
  AuthenticatedAnalyticsRoute: typeof AuthenticatedAnalyticsRoute
  AuthenticatedApVendorsRoute: typeof AuthenticatedApVendorsRouteWithChildren
  AuthenticatedCatalogSearchRoute: typeof AuthenticatedCatalogSearchRoute
  AuthenticatedCatalogSourcesRoute: typeof AuthenticatedCatalogSourcesRoute
  AuthenticatedCommunicationsRoute: typeof AuthenticatedCommunicationsRoute
  AuthenticatedCompanyRoute: typeof AuthenticatedCompanyRoute
  AuthenticatedContactsRoute: typeof AuthenticatedContactsRouteWithChildren
  AuthenticatedCustomerCommsRoute: typeof AuthenticatedCustomerCommsRouteWithChildren
  AuthenticatedCustomersRoute: typeof AuthenticatedCustomersRouteWithChildren
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedE2eTestingRoute: typeof AuthenticatedE2eTestingRoute
  AuthenticatedInvoicesRoute: typeof AuthenticatedInvoicesRouteWithChildren
  AuthenticatedLearnRoute: typeof AuthenticatedLearnRouteWithChildren
  AuthenticatedManufacturersRoute: typeof AuthenticatedManufacturersRouteWithChildren
  AuthenticatedOrderReviewRoute: typeof AuthenticatedOrderReviewRouteWithChildren
  AuthenticatedOrdersRoute: typeof AuthenticatedOrdersRouteWithChildren
  AuthenticatedPriceMatchingRoute: typeof AuthenticatedPriceMatchingRoute
  AuthenticatedProductsRoute: typeof AuthenticatedProductsRouteWithChildren
  AuthenticatedProjectsRoute: typeof AuthenticatedProjectsRouteWithChildren
  AuthenticatedPurchaseOrdersRoute: typeof AuthenticatedPurchaseOrdersRouteWithChildren
  AuthenticatedQualityTiersRoute: typeof AuthenticatedQualityTiersRoute
  AuthenticatedQuotedVsActualRoute: typeof AuthenticatedQuotedVsActualRoute
  AuthenticatedQuotesRoute: typeof AuthenticatedQuotesRouteWithChildren
  AuthenticatedReceivablesRoute: typeof AuthenticatedReceivablesRouteWithChildren
  AuthenticatedShipmentsRoute: typeof AuthenticatedShipmentsRouteWithChildren
  AuthenticatedShippingCalculatorRoute: typeof AuthenticatedShippingCalculatorRouteWithChildren
  AuthenticatedSourcesRoute: typeof AuthenticatedSourcesRoute
  AuthenticatedSpecialsRoute: typeof AuthenticatedSpecialsRoute
  AuthenticatedStaffRoute: typeof AuthenticatedStaffRouteWithChildren
  AuthenticatedStoreReadinessRoute: typeof AuthenticatedStoreReadinessRoute
  AuthenticatedSuppliersRoute: typeof AuthenticatedSuppliersRouteWithChildren
  AuthenticatedTaxExemptionsRoute: typeof AuthenticatedTaxExemptionsRouteWithChildren
  AuthenticatedTaxRatesRoute: typeof AuthenticatedTaxRatesRoute
  AuthenticatedWarehouseRoute: typeof AuthenticatedWarehouseRouteWithChildren
  AuthenticatedWarrantyClaimsRoute: typeof AuthenticatedWarrantyClaimsRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAiRoute: AuthenticatedAiRouteWithChildren,
  AuthenticatedAiCostsRoute: AuthenticatedAiCostsRoute,
  AuthenticatedAnalyticsRoute: AuthenticatedAnalyticsRoute,
  AuthenticatedApVendorsRoute: AuthenticatedApVendorsRouteWithChildren,
  AuthenticatedCatalogSearchRoute: AuthenticatedCatalogSearchRoute,
  AuthenticatedCatalogSourcesRoute: AuthenticatedCatalogSourcesRoute,
  AuthenticatedCommunicationsRoute: AuthenticatedCommunicationsRoute,
  AuthenticatedCompanyRoute: AuthenticatedCompanyRoute,
  AuthenticatedContactsRoute: AuthenticatedContactsRouteWithChildren,
  AuthenticatedCustomerCommsRoute: AuthenticatedCustomerCommsRouteWithChildren,
  AuthenticatedCustomersRoute: AuthenticatedCustomersRouteWithChildren,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedE2eTestingRoute: AuthenticatedE2eTestingRoute,
  AuthenticatedInvoicesRoute: AuthenticatedInvoicesRouteWithChildren,
  AuthenticatedLearnRoute: AuthenticatedLearnRouteWithChildren,
  AuthenticatedManufacturersRoute: AuthenticatedManufacturersRouteWithChildren,
  AuthenticatedOrderReviewRoute: AuthenticatedOrderReviewRouteWithChildren,
  AuthenticatedOrdersRoute: AuthenticatedOrdersRouteWithChildren,
  AuthenticatedPriceMatchingRoute: AuthenticatedPriceMatchingRoute,
  AuthenticatedProductsRoute: AuthenticatedProductsRouteWithChildren,
  AuthenticatedProjectsRoute: AuthenticatedProjectsRouteWithChildren,
  AuthenticatedPurchaseOrdersRoute:
    AuthenticatedPurchaseOrdersRouteWithChildren,
  AuthenticatedQualityTiersRoute: AuthenticatedQualityTiersRoute,
  AuthenticatedQuotedVsActualRoute: AuthenticatedQuotedVsActualRoute,
  AuthenticatedQuotesRoute: AuthenticatedQuotesRouteWithChildren,
  AuthenticatedReceivablesRoute: AuthenticatedReceivablesRouteWithChildren,
  AuthenticatedShipmentsRoute: AuthenticatedShipmentsRouteWithChildren,
  AuthenticatedShippingCalculatorRoute:
    AuthenticatedShippingCalculatorRouteWithChildren,
  AuthenticatedSourcesRoute: AuthenticatedSourcesRoute,
  AuthenticatedSpecialsRoute: AuthenticatedSpecialsRoute,
  AuthenticatedStaffRoute: AuthenticatedStaffRouteWithChildren,
  AuthenticatedStoreReadinessRoute: AuthenticatedStoreReadinessRoute,
  AuthenticatedSuppliersRoute: AuthenticatedSuppliersRouteWithChildren,
  AuthenticatedTaxExemptionsRoute: AuthenticatedTaxExemptionsRouteWithChildren,
  AuthenticatedTaxRatesRoute: AuthenticatedTaxRatesRoute,
  AuthenticatedWarehouseRoute: AuthenticatedWarehouseRouteWithChildren,
  AuthenticatedWarrantyClaimsRoute: AuthenticatedWarrantyClaimsRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  CallbackRoute: CallbackRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
